import { useEffect, useRef, useState } from "react";
import Scanner from "../components/Scanner";
import CamScanner from "../components/CamScanner";
import Loading from "../components/Loading";
import * as XLSX from "xlsx";
import "./Stockin.css";
import { apiFetch } from "../components/api"
import AutocompleteSelect from "../components/FilterSelect";

export default function StockInPage() {
  // ───────── 상태 ─────────
  const [items, setItems] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");
  const searchInputRef = useRef(null);

  const [selected, setSelected] = useState(null);
  const [stateOptions, setStateOptions] = useState([]);
  const [qty, setQty] = useState("");
  const qtyRef = useRef(null);

  const [msg, setMsg] = useState("");
  const username = localStorage.getItem("username") || "unknown";

  // ─ 신규 추가 모달 상태
  const [addOpen, setAddOpen] = useState(false);
  const [initLoaded, setInitLoaded] = useState(false);
  const [catList, setCatList] = useState([]);
  const [majorPkgList, setMajorPkgList] = useState([]);
  const [locList, setLocList] = useState([]);
  const [pkgOptions, setPkgOptions] = useState([]);
  
  const [selCategory, setSelCategory] = useState("");
  const [selMajorPkg, setSelMajorPkg] = useState("");
  const [selPackage, setSelPackage] = useState("");
  const [selLocation, setSelLocation] = useState("");
  const [selState, setSelState] = useState("");
  const [pkgText, setPkgText] = useState("");
  const [descText, setDescText] = useState("");
  const [locText, setLocText] = useState("");
  const [catText, setCatText] = useState("");
  const [majorPkgText, setMajorPkgText] = useState("");

  const [newName, setNewName] = useState("");
  const [newValue, setNewValue] = useState("");

  const [supplierName, setSupplierName] = useState("");
  const [unitPrice, setUnitPrice] = useState("");
  const [supplierList, setSupplierList] = useState([]);
  const [supModal, setSupModal] = useState({ open: false, name: "", address: "", description: "" });
  const [pkgAuto, setPkgAuto] = useState(false);

  const [lookup, setLookup] = useState(null);
  const [lockCatPkg, setLockCatPkg] = useState(false);
  const [locLock, setLocLock] = useState(false);
  const [lookupErr, setLookupErr] = useState(null);
  const [lookupStatus, setLookupStatus] = useState("idle"); 
  const [specForm, setSpecForm] = useState({});
  const lastLookupRef = useRef("");
  
  //spec modal
  const [specOpen, setSpecOpen] = useState(false);
  const [specMeta, setSpecMeta] = useState(null); // { groups: {GROUP: {label, fields}} }
  const [specGroup, setSpecGroup] = useState("");
  const [specValues, setSpecValues] = useState({});
  const [specJson, setSpecJson] = useState("{}");
  const [specCopyMsg, setSpecCopyMsg] = useState("");
  
  //excel
  const [excelMode, setExcelMode] = useState(false);
  const [excelRows, setExcelRows] = useState([]);
  const excelFileRef = useRef(null);
  const [excelLoading, setExcelLoading] = useState(false);
  const [excelUploading, setExcelUploading] = useState(false);
  const [excelSubPkgMap, setExcelSubPkgMap] = useState({})
  const [excelSpecTarget, setExcelSpecTarget] = useState(null)
  const exlocationLookupRef = useRef(new Map());

  const hasUploadResult = excelRows.some(r => r.__uploadDone);
  const scannerRef = useRef(null);

  //print
  const [labelProfile, setLabelProfile] = useState(null);
  const [uploadedBarcodes, setUploadedBarcodes] = useState([]);

  //Fuzzy
  const [similarBest, setSimilarBest] = useState(null)
  const [similarList, setSimilarList] = useState([])
  const [similarOpen, setSimilarOpen] = useState(false)
  const [similarLoading, setSimilarLoading] = useState(false)

  const [excelFuzzyMap, setExcelFuzzyMap] = useState({}) 
  const [excelSimilarOpen, setExcelSimilarOpen] = useState(false)
  const [excelSimilarTarget, setExcelSimilarTarget] = useState(null) // { rowId, query }
  const [excelSimilarBest, setExcelSimilarBest] = useState(null)
  const [excelSimilarList, setExcelSimilarList] = useState([])
  const [excelSimilarLoading, setExcelSimilarLoading] = useState(false)

  const focusScanner = () => {
    if (scannerRef.current) scannerRef.current.focus();
  };

  const stripMajorPrefix = (label, majorName) => {
    if (!label || !majorName) return null;
    const re = new RegExp(`^\\s*${escapeRegExp(majorName)}\\s*[-\\/]\\s*(\\S.*)$`, "i");
    const m = label.match(re);
    return m ? m[1] : null;
  };
  const majorName = majorPkgList.find(m => String(m.id) === String(selMajorPkg))?.name || "";

  useEffect(() => {
    const handleFocus = () => {
      if (scannerRef.current) {
        // 혹시 렌더링 타이밍 때문에 늦게 잡히는 경우 대비해 지연 포커스
        setTimeout(() => {
          scannerRef.current.focus();
        }, 100);
      }
    };

    window.addEventListener("focus", handleFocus);

    const handleVisibilityChange = () => {
      if (!document.hidden) {
        handleFocus();
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      window.removeEventListener("focus", handleFocus);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);
  
  // ───────── 데이터 로드 ─────────
  useEffect(() => {
    let alive = true;

    (async () => {
      try {
        setLoading(true);
        setError(null);

        const [stateRes, supplierRes, inventoryRes, quickAddRes, specMetaRes] = await Promise.all([
          apiFetch("/api/inventory/states/", { cache: "no-store" }),
          apiFetch("/api/product/suppliers/", { cache: "no-store" }),
          apiFetch("/api/inventory/", { cache: "no-store" }),
          apiFetch("/api/product/quick-list/", { cache: "no-store" }),
          apiFetch("/api/product/specmeta/", { cache: "no-store" }),
        ]);

        let profileRes = null;
        try {
          profileRes = await apiFetch("/api/print/profile/default/", { method: "GET" });
        } catch {
          profileRes = null;
        }

        if (!alive) return;
        
        // 상태
        setStateOptions(Array.isArray(stateRes?.data) ? stateRes.data : []);

        // 구매처
        const suppliers = Array.isArray(supplierRes)
          ? supplierRes
          : (supplierRes?.suppliers || []);
        setSupplierList(suppliers);

        // 재고
        const items = Array.isArray(inventoryRes?.data) ? inventoryRes.data : [];
        setItems(items);
        setFiltered([]);

        // QuickAdd 옵션 3종
        setCatList(Array.isArray(quickAddRes?.categories) ? quickAddRes.categories : []);
        setMajorPkgList(Array.isArray(quickAddRes?.major_packages) ? quickAddRes.major_packages : []);
        setLocList(Array.isArray(quickAddRes?.locations) ? quickAddRes.locations : []);
        setInitLoaded(true);

        //스펙메타
        setSpecMeta(specMetaRes || { groups: {} });

        if (profileRes?.ok) {
          setLabelProfile(profileRes.last_profile || "");
        } else {
          setLabelProfile("");
        }

        setTimeout(() => searchInputRef.current?.focus?.(), 50);
      } catch (e) {
        if (!alive) return;
        setStateOptions([]);
        setSupplierList([]);
        setCatList([]);
        setMajorPkgList([]);
        setLocList([]);
        setError(e?.message || "불러오기 실패");
      } finally {
        if (alive) setLoading(false);
      }
    })();

    return () => {
      alive = false;
    };
  }, []);

  

  // ───────── 유틸(검색 하이라이트) ─────────
  const escapeRegExp = (s) => String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const htmlEscape = (s) =>
    String(s ?? "").replace(/[&<>"']/g, (m) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[m]));
  const tokenizeQuery = (input) => {
    const s = String(input || "").trim();
    if (!s) return [];

    const tokens = [];
    const re = /[^\s&|]+="[^"]+"|"[^"]+"|[^&|\s]+/g;
    let m;

    while ((m = re.exec(s)) !== null) {
      const token = m[0].trim();
      if (token) tokens.push(token);
    }

    return tokens;
  };
  const highlightHTML = (text) => {
    const src = String(text ?? "");
    const q = String(searchTerm ?? "").trim();
    if (!q || !src) return htmlEscape(src);

    const rawTokens = [];
    const orGroups = q.split("|").map((g) => g.trim()).filter(Boolean);

    for (const group of orGroups) {
      const tokens = tokenizeQuery(group);
      rawTokens.push(...tokens);
    }

    const terms = [];
    for (const tok of rawTokens) {
      if (tok.startsWith("!")) continue;

      const raw = tok.startsWith("!") ? tok.slice(1) : tok;
      const eq = raw.indexOf("=");

      if (eq > 0) {
        let val = raw.slice(eq + 1).trim();
        if (
          (val.startsWith('"') && val.endsWith('"')) ||
          (val.startsWith("'") && val.endsWith("'"))
        ) {
          val = val.slice(1, -1);
        }
        if (val) terms.push(val);
      } else {
        let val = raw.trim();
        if (
          (val.startsWith('"') && val.endsWith('"')) ||
          (val.startsWith("'") && val.endsWith("'"))
        ) {
          val = val.slice(1, -1);
        }
        if (val) terms.push(val);
      }
    }

    const hlTerms = [...new Set(terms)]
      // .filter(Boolean)
      .filter((t) => t.length >= 2)
      .sort((a, b) => b.length - a.length);

    if (hlTerms.length === 0) return htmlEscape(src);

    const re = new RegExp(`(${hlTerms.map(escapeRegExp).join("|")})`, "gi");

    return src
      .split(re)
      .map((seg, i) => i % 2 ? `<mark>${htmlEscape(seg)}</mark>` : htmlEscape(seg))
      .join("");
  };
  const normalizeModelName = (s) => String(s || "").replace(/\s+/g, "");

  // ───────── 검색(&, |, !) ─────────
  useEffect(() => {
    if (!searchTerm.trim()) {
      setFiltered([]);
      return;
    }
    if (excelMode) setExcelMode(false);

    setSelected(null);
    setQty("");

    const matchItem = (item) => {
      const fields = {
        "카테고리": `${item.category_display_name || ""}`.toLowerCase(),
        "대분류": `${item.product__category__major_category__name || ""}`.toLowerCase(),
        "소분류": `${item.product__category__name || ""}`.toLowerCase(),
        "품명": `${item.product__name || ""}`.toLowerCase(),
        // "패키지": `${item.product__package__major_package__name || ""} ${item.product__package__option || ""}`.toLowerCase(),
        "패키지": `${item.product__package_display || ""}`.toLowerCase(),
        "스펙": `${item.product__display_spec || ""}`.toLowerCase(),
        "설명": `${item.product__description || ""}`.toLowerCase(),
        "위치": `${item.location_display_name || ""} ${item.temp_inventory || ""}`.toLowerCase(),
        "상태": `${item.state__name || ""}`.toLowerCase(),
        "바코드": `${item.barcode || ""} ${item.location_barcode || ""}`.toLowerCase(),
      };

      const allText = Object.values(fields).join(" ");

      const st = (searchTerm || "").toLowerCase().trim();
      if (!st) return true;

      // 공백은 AND, | 는 OR
      const orGroups = st
        .split("|")
        .map((g) => g.trim())
        .filter(Boolean);

      const evalAtom = (tok) => {
        // NOT
        const neg = tok.startsWith("!");
        const t = neg ? tok.slice(1) : tok;

        // 필드 지정: 키=값
        const eq = t.indexOf("=");
        if (eq > 0) {
          const key = t.slice(0, eq).trim();
          const val = t.slice(eq + 1).trim();
          const target = fields[key];
          const ok = !!target && (val ? target.includes(val) : true);
          return neg ? !ok : ok;
        }

        // 기본: 전체 검색
        const ok = allText.includes(t);
        return neg ? !ok : ok;
      };

      const evalAndGroup = (group) => {
        const tokens = tokenizeQuery(group);

        return tokens.every((tok) => {
          const neg = tok.startsWith("!");
          const raw = neg ? tok.slice(1) : tok;

          const eq = raw.indexOf("=");
          if (eq > 0) {
            const key = raw.slice(0, eq).trim();
            let val = raw.slice(eq + 1).trim();

            if (
              (val.startsWith('"') && val.endsWith('"')) ||
              (val.startsWith("'") && val.endsWith("'"))
            ) {
              val = val.slice(1, -1);
            }

            return evalAtom(`${neg ? "!" : ""}${key}=${val}`);
          }

          let val = raw;
          if (
            (val.startsWith('"') && val.endsWith('"')) ||
            (val.startsWith("'") && val.endsWith("'"))
          ) {
            val = val.slice(1, -1);
          }

          const ok = allText.includes(val);
          return neg ? !ok : ok;
        });
      };

      // OR 그룹 중 하나라도 만족하면 true
      return orGroups.some(evalAndGroup);
    };

    setFiltered(
      items
        .filter(matchItem)
        .sort((a, b) => {
          const cA = `${a.category_display_name || ""}`.toLowerCase()
          const cB = `${b.category_display_name || ""}`.toLowerCase()
          if (cA < cB) return -1
          if (cA > cB) return 1

          const pA = (a.product__name || "").toLowerCase()
          const pB = (b.product__name || "").toLowerCase()
          if (pA < pB) return -1
          if (pA > pB) return 1

          return Number(a.id) - Number(b.id)
        })
    )
  }, [searchTerm, items]);

  // 선택 시 수량 포커스
  useEffect(() => {
    if (selected) setTimeout(() => qtyRef.current?.focus?.(), 50);
  }, [selected]);

  // 제품 룩업
  useEffect(() => {
    if (!addOpen) {
      setLookup(null);
      setLockCatPkg(false);
      setLookupErr(null);
      setLookupStatus("idle");
      lastLookupRef.current = "";

      setSimilarBest(null)
      setSimilarList([])
      setSimilarOpen(false)
      setSimilarLoading(false)
      return;
    }

    const name = (newName || "").trim();
    setLookup(null);
    setLockCatPkg(false);
    setLookupErr(null);

    if (!name) {
      setLookupStatus("idle");
      lastLookupRef.current = "";
      return;
    }

    // 같은 값이면 중복 조회 방지
    if (lastLookupRef.current === name) return;
    lastLookupRef.current = name;

    const ctrl = new AbortController();

    const t = setTimeout(async () => {
      try {
        setLookupStatus("checking");

        const qs = new URLSearchParams({ name });
        const j = await apiFetch(`/api/product/lookup/?${qs.toString()}`, {
          signal: ctrl.signal,
          cache: "no-store",
        });

        setLookupStatus("exists");
        setLockCatPkg(true);
        setLookup(j);
        setLookupErr(null);

        if (j.category_id) {
          setSelCategory(String(j.category_id));
          setCatText(String(j.category_label));
        }

        if (j.major_package_id) {
          setSelMajorPkg(String(j.major_package_id));
          setMajorPkgText(String(j.major_package_name));
          await fetchPkgOptions(j.major_package_id);

          if (j.package_label) {
            setPkgText(j.package_label);
            setPkgAuto(true);
          } else {
            setPkgText("");
            setPkgAuto(false);
          }
        } else {
          setPkgOptions([]);
          setSelPackage("");
          setPkgText("");
          setPkgAuto(false);
        }

        if (j.spec !== undefined && j.spec !== null) {
          setNewValue(typeof j.spec === "string" ? j.spec : JSON.stringify(j.spec))
        } else {
          setNewValue("")
        }
        if (j.description) setDescText(String(j.description));
      } catch (e) {
        if (ctrl.signal.aborted) return;

        const msg = String(e?.message || "");

        // 제품 없음(정상 신규)
        if (msg.includes("404") || msg.includes("PRODUCT_NOT_FOUND")) {
          setSelCategory("");
          setCatText("");
          setSelMajorPkg("");
          setMajorPkgText("");
          setPkgText("");

          setLocText("");
          setLocLock(false);
          setSelLocation("");

          setNewValue("");
          setLookupStatus("new");
          setLookup(null);
          setLockCatPkg(false);
          setLookupErr(null);

          setSimilarOpen(false)
          fetchSimilar(name)
          return;
        }

        setLookupStatus("error");
        setLookup(null);
        setLockCatPkg(false);
        setLookupErr("조회 통신 오류");
      }
    }, 250);

    return () => {
      ctrl.abort();
      clearTimeout(t);
    };
  }, [newName]);
  
  useEffect(() => {
    const run = async () => {
      const productname = String(newName || "").trim();
      const stateId = String(selState || "").trim();

      if (!productname || !stateId) return;

      const st = stateOptions.find(s => String(s.id) === stateId);
      const stateName = String(st?.name || "").trim();
      if (!stateName) return;

      setLoading(true);

      try {
        setLocLock(true);

        const qs = new URLSearchParams({ productname, state: stateName });
        const j = await apiFetch(`/api/inventory/lookup/?${qs.toString()}`, {
          method: "GET",
          cache: "no-store",
        });

        if (!j?.exists) {
          setLocText("");
          setSelLocation("")
          setLocLock(false);
          return;
        }

        setLocText(j.name_full || "");
        if (j.location_id) setSelLocation(String(j.location_id))
        setLocLock(true);
      } catch (e) {
        setLocText("");
        setSelLocation("")
        setLocLock(false);
      } finally {
        setLoading(false);
      }
    };

    if (!lockCatPkg) return;
    if (lookupStatus !== "exists") return;
    run();
  }, [selState, lookupStatus]);

  useEffect(() => {
    if (searchTerm.trim()) setAddOpen(false);
  }, [searchTerm]);

  useEffect(() => {
    if (msg) {
      alert(msg);
      setMsg("");
    }
  }, [msg]);

  useEffect(() => {
    if (Array.isArray(stateOptions) && stateOptions.length > 0) {
      const fresh = stateOptions.find(s => (s.name || "").trim() === "신품");
      if (fresh) setSelState(String(fresh.id));
    }
  }, [addOpen]);


  useEffect(() => {
    if (!excelMode) return

    const ids = Array.from(
      new Set(
        excelRows
          .map(r => String(r.__packageId || "").trim())
          .filter(Boolean)
      )
    )

    ids.forEach((id) => {
      if (!excelSubPkgMap[id]) fetchExcelSubPkgs(id)
    })
  }, [excelMode, excelRows])

  // 스펙 모달
  const isSpecJsonCellError = (group, values) => {
    const fields = getGroupFields(group);
    const allowed = new Set(Object.keys(fields || {}));

    if (!group) return false;
    if (!allowed.size) return false;

    for (const [k, raw] of Object.entries(values || {})) {
      if (!allowed.has(k)) continue;

      const def = fields[k] || {};
      const typ = def.type || "text";
      const multi = def.multi === true;

      if (typ === "bool") {
        const b = parseBool(raw);
        if (b === null && String(raw ?? "").trim()) return true;
        continue;
      }

      if (multi) {
        const sep = def.sep || "|";
        const parts = Array.isArray(raw)
          ? raw.map((x) => String(x ?? "").trim()).filter(Boolean)
          : String(raw ?? "").split(sep).map((x) => String(x).trim()).filter(Boolean);

        if (String(raw ?? "").trim() && parts.length === 0) return true;

        if (def.type === "choice") {
          const allowedChoices = new Set((def.choices || []).map((c) => String(c.value)));
          if (parts.some((v) => !allowedChoices.has(String(v)))) return true;
        }
        continue;
      }

      const s = String(raw ?? "").trim();
      if (!s) continue;

      if (typ === "decimal") {
        if (k === "watt") {
          if (!isDecimalLike(s) && !isFractionLike(s)) return true;
        } else {
          if (!isDecimalLike(s)) return true;
        }
        continue;
      }

      if (typ === "int") {
        if (!isIntLike(s)) return true;
        continue;
      }

      if (typ === "choice") {
        const allowedChoices = new Set((def.choices || []).map((c) => String(c.value)));
        if (!allowedChoices.has(s)) return true;
        continue;
      }

      if (typ === "string") {
        if (!s) return true;
      }
    }

    return false;
  };
  
  const applySpecJson = () => {
    if (isSpecJsonCellError(specGroup, specValues)) return;
    const json = String(specJson || "{}")

    if (excelSpecTarget?.mode === "excel") {
      const rowId = excelSpecTarget.rowId
      setExcelRows(prev =>
        prev.map(r => (r.__id === rowId ? { ...r, Spec: json } : r))
      )
      closeSpecEditor()
      return
    }

    setNewValue(json)
    closeSpecEditor()
  }

  const openSpecEditor = async () => {
    const catId = String(selCategory || "").trim()

    let autoGroup = ""
    if (catId) {
      const hit = catList.find(c => String(c.id) === String(catId))
      autoGroup = String(hit?.spec || "").trim().toUpperCase()
    }

    setSpecCopyMsg("")

    const meta = specMeta || { groups: {} };
    const key = String(autoGroup || "").trim().toUpperCase()
    const nextGroup = meta?.groups?.[key] ? key : "ETC"
    setSpecGroup(nextGroup)
    setSpecOpen(true)

    // 기본 입력값: newValue가 JSON이면 그걸로 채우기(원치 않으면 삭제)
    try {
      const parsed = JSON.parse(String(newValue || "{}"))
      setSpecValues(parsed && typeof parsed === "object" ? parsed : {})
    } catch {
      setSpecValues({})
    }
  }

  const openSpecEditorExcel = async (row) => {
    const catId = String(row?.__categoryId || "").trim()

    let autoGroup = ""
    if (catId) {
      const hit = catList.find(c => String(c.id) === String(catId))
      autoGroup = String(hit?.spec || "").trim().toUpperCase()
    }

    setExcelSpecTarget({ mode: "excel", rowId: row.__id })
    setSpecOpen(true)
    setSpecCopyMsg("")

    // 메타 로드
    const meta = specMeta || { groups: {} };
    const saved = String(row?.__specGroup || "").trim().toUpperCase()
    const key = String(autoGroup || "").trim().toUpperCase()
    const picked = saved || key
    const nextGroup = meta?.groups?.[picked] ? picked : "ETC"
    setSpecGroup(nextGroup)

    // 기존 값이 JSON이면 모달에 반영
    try {
      const parsed = JSON.parse(String(row?.Spec || "{}"))
      setSpecValues(parsed && typeof parsed === "object" ? parsed : {})
    } catch {
      setSpecValues({})
    }
  }
  
  const closeSpecEditor = () => {
    setSpecOpen(false);
    setSpecGroup("");
    setSpecValues({});
    setSpecJson("{}");
    setSpecCopyMsg("");
    setExcelSpecTarget(null)
  };

  const getGroupsList = () => {
    const g = specMeta?.groups || {};
    return Object.keys(g).sort((a, b) => a.localeCompare(b));
  };

  const getGroupFields = (group) => {
    const g = specMeta?.groups?.[group] || {};
    return g.fields || {};
  };

  const parseBool = (v) => {
    if (v === true || v === false) return v;
    const s = String(v ?? "").trim().toLowerCase();
    if (s === "true" || s === "1" || s === "y" || s === "yes" || s === "on") return true;
    if (s === "false" || s === "0" || s === "n" || s === "no" || s === "off") return false;
    return null;
  };

  const buildSpecObject = (group, values) => {
    const fields = getGroupFields(group);
    const allowed = new Set(Object.keys(fields || {}));

    const out = {};
    for (const [k, raw] of Object.entries(values || {})) {
      if (!allowed.has(k)) continue;

      const def = fields[k] || {};
      const typ = def.type || "text";
      const multi = def.multi === true;

      if (typ === "bool") {
        const b = parseBool(raw);
        if (b === null) continue;
        out[k] = b;
        continue;
      }

      if (multi) {
        // multi=true면 배열/문자열 둘 다 허용. 값은 "|"로 합쳐서 저장(백엔드와 동일 규칙)
        if (Array.isArray(raw)) {
          const cleaned = raw.map((x) => String(x ?? "").trim()).filter(Boolean);
          if (cleaned.length === 0) continue;
          out[k] = cleaned.join(def.sep || "|");
          continue;
        }
        const s = String(raw ?? "").trim();
        if (!s) continue;
        out[k] = s;
        continue;
      }

      // 숫자/문자 모두: 빈값만 제거, 나머지는 문자열 그대로(원하시면 숫자 캐스팅도 가능)
      const s = String(raw ?? "").trim();
      if (!s) continue;
      out[k] = s;
    }

    return out;
  };

  useEffect(() => {
    if (!specOpen) return;

    const obj = buildSpecObject(specGroup, specValues);
    // 그룹이 비어있으면 value만 쓰게 하고 싶으면 여기서 처리 가능
    const line = JSON.stringify(obj);
    setSpecJson(line);
  }, [specOpen, specGroup, specValues]);

  const copySpecJson = async () => {
    try {
      await navigator.clipboard.writeText(String(specJson || "{}"));
      setSpecCopyMsg("복사되었습니다.");
      setTimeout(() => setSpecCopyMsg(""), 1200);
    } catch (e) {
      alert("복사 실패: 클립보드 권한을 확인하세요.");
    }
  };

  // 신규 품목 추가(모달)
  const openAdd = () => {
    setSearchTerm("");
    setFiltered([]);
    setSelected(null);
    setQty("");
    setSupplierName("");
    setLocText("");
    setSelLocation("");
    setUnitPrice("");
    setAddOpen(true);

    // setNewName(""); setNewValue("");
    setSelCategory(""); setCatText("");

    setSelMajorPkg(""); setMajorPkgText("");
    setPkgText(""); 
  };

  const fetchPkgOptions = async (majorId) => {
    setPkgOptions([]);
    setSelPackage("");
    if (!majorId) return;

    try {
      setLoading(true);
      const j = await apiFetch(`/api/product/by-major/${majorId}/`, { cache: "no-store" });
      setPkgOptions(j?.options || []);
    } catch(e) {
      alert(`메이저 패키지 로드 에러 : ${e?.message || "알 수 없는 오류"}`);
      setPkgOptions([]);
    } finally {
      setLoading(false);
    }
  };

  // ───────── 입고 처리: 기존 + 수량 → ─────────
  const handleStockIn = async () => {
    if (!selected) return setMsg("제품을 먼저 선택하십시오.");
    const addQty = Number(qty);
    if (!Number.isFinite(addQty) || addQty <= 0) return setMsg("입고 수량을 바르게 입력하십시오.");

    const prevStock = Number(selected.stock) || 0;
    const newStock = prevStock + addQty;

    try {
      setLoading(true);
      const j = await apiFetch(`/api/inventory/${selected.id}/stock/`, {
        method: "PATCH",
        body: { stock: newStock, action: "IN", username },
      });

      setItems(p => p.map(it => (it.id === selected.id ? { ...it, stock: j.stock } : it)));
      setFiltered(p => p.map(it => (it.id === selected.id ? { ...it, stock: j.stock } : it)));
      setSelected(prev => (prev ? { ...prev, stock: j.stock } : prev));

      setMsg(`✅ ${selected.product__name || selected.name}\n▶ 입고 +${addQty} \n▶ 재고 ${prevStock} → ${j.stock}`);

      const productId = selected.product_id || selected.product__id;
      if (productId && (supplierName || unitPrice > 0)) {
        await recordPurchase(productId, addQty, supplierName, unitPrice);
      }

      setQty("");
      setUnitPrice("");
      setSupplierName("");
      setTimeout(() => qtyRef.current?.focus?.(), 50);
    } catch (e) {
      setMsg(`수량 로드 에러 : ${e?.message || "알 수 없는 오류"}`);
    } finally {
      setLoading(false);
    }
  };

  const submitAddProduct = async () => {
    const nameForApi = normalizeModelName(newName);
    let locationId = selLocation;

    if (!nameForApi) return alert("제품명을 입력하세요.");
    if (!selCategory) return alert("카테고리를 선택하세요.");
    if (!selMajorPkg) return alert("메이저 패키지를 선택하세요.");
    
    if (!locationId && locText) {
      const norm = (s) => String(s || "").replace(/\s+/g, "").toLowerCase();
      const hit = locList.find((l) => norm(l.name_full) === norm(locText));
      if (hit) {
        locationId = String(hit.id);
        setSelLocation(locationId); // UI 동기화용
      }
    }
    if (!locationId) return alert("보관 위치를 선택하세요.");
    if (!selState) return alert("상태를 선택하세요.");

    const qtyNum = Number(qty) || 0;
    const supplierKey = String(supplierName || "").trim();
    const isStockRegisterSupplier = supplierKey === "재고등록";

    if (qtyNum >= 1) {
      if (!supplierKey) return alert("수량이 1 이상일 때는 구매처가 필수입니다.");

      const priceNum = Number(unitPrice);
      const priceOk = isStockRegisterSupplier
        ? Number.isFinite(priceNum) && priceNum >= 0
        : Number.isFinite(priceNum) && priceNum > 0;

      if (!priceOk) {
        return alert(
          isStockRegisterSupplier
            ? "구매처가 재고등록일 때 단가는 0 이상 숫자여야 합니다."
            : "수량이 1 이상일 때는 단가가 0보다 큰 숫자여야 합니다."
        );
      }
    }

    if (!ensureLabelProfile(`${nameForApi} 품목을 업로드 하시겠습니까?`)) return;

    let package_id = null;
    if (pkgText) {
      const hit = pkgOptions.find(p => p.label === pkgText || String(p.id) === pkgText);
      if (hit) package_id = hit.id;
    }

    const state_id = selState ? Number(selState) : null;
    const location_id = locationId ? Number(locationId) : null

    try {
      setLoading(true);
      const j = await apiFetch("/api/product/create/", {
        method: "POST",
        body: {
          name: nameForApi,
          spec: newValue.trim(),
          description: descText.trim(),
          category_id: selCategory,
          package_id,
          major_package_id: package_id ? null : (selMajorPkg || null),
          package_free_text: package_id ? null : (pkgText || null),
          location_id,
          state_id,
          username,
          initial_qty: Number(qty) || 0,
        },
      });

      const it = j.inventory_row;

      const nameLabel = it.product__name || nameForApi;
      const pkgLabel = [
        it.product__package__major_package__name || "",
        it.product__package__option ? `-${it.product__package__option}` : ""
      ].join("");

      const header = j.updated_only ? j.message : "✅ 신규 품목 등록 완료";
      alert(
        `${header}\n` +
        `▶ 품명: ${nameLabel}\n` +
        `▶ 카테고리: ${pkgLabel || "미지정"}\n` +
        `▶ 패키지: ${
          (it.product__category__major_category__name || "") +
          " / " +
          (it.product__category__name || "")
        }\n` +
        `▶ 위치: ${
          it.location__container__name
            ? `${it.location__major__name ? it.location__major__name + "-" : ""}${it.location__container__name}${it.location__name ? "-" + it.location__name : ""}`
            : "위치 없음"
        }\n` +
        `▶ 상태: ${it.state__name || ""}`
      );

      setItems(p => [it, ...p]);
      if (searchTerm.trim()) setFiltered(p => [it, ...p]);
      setAddOpen(false);

      const initialQty = Number(qty) || 0;
      const newProdId = j.inventory_row?.product_id;
      if (newProdId && initialQty > 0 && (supplierName || Number(unitPrice) > 0)) {
        await recordPurchase(newProdId, initialQty, supplierName, unitPrice);
      }

      await confirmAndPrint(nameLabel, it.barcode);

      setNewName(""); setNewValue("");
      setSelCategory(""); setCatText("");

      setSelMajorPkg(""); setMajorPkgText("");
      setSelPackage(""); setPkgText(""); 
      setPkgOptions([]);
      
      setSelLocation("");
      setSelState("");

      setLocText("");
      setLocLock(false);

      setSupplierName("");
      setUnitPrice("");
      setTimeout(() => qtyRef.current?.focus?.(), 50);
    } catch (e) {
      alert(`등록 실패 : ${e?.message || "알 수 없는 오류"}`);
    } finally {
      setLoading(false);
    }
  };

  const recordPurchase = async (productId, addQty, supplier, price) => {
    try {
      await apiFetch("/api/product/purchase/", {
        method: "POST",
        body: {
          product_id: productId,
          quantity: addQty,
          price: Number(price) || 0,
          supplier_name: supplier || null,
        },
      });
    } catch (e) {
      alert(`구매 이력 저장 에러 : ${e?.message || "알 수 없는 오류"}`);
    }
  };

  const createSupplier = async () => {
    const name = (supModal.name || "").trim();
    if (!name) return alert("구매처 이름을 입력하세요.");

    try {
      setLoading(true);
      const j = await apiFetch("/api/product/suppliers/", {
        method: "POST",
        body: {
          name,
          address: supModal.address || null,
          description: supModal.description || "",
        },
      });

      setSupplierList(prev => {
        const exists = prev.find(x => x.id === j.id);
        const next = exists ? prev.map(x => (x.id === j.id ? j : x)) : [...prev, j];
        return next.sort((a, b) => a.name.localeCompare(b.name));
      });

      setSupplierName(j.name);
      setSupModal({ open: false, name: "", address: "", description: "" });
    } catch (e) {
      alert(`구매처 로드 에러 : ${e?.message || "알 수 없는 오류"}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const onEsc = (e) => {
      if (e.key !== "Escape") return;

      if (similarOpen) {
        e.preventDefault()
        e.stopPropagation()
        setSimilarOpen(false)
        return
      }

      if (specOpen) {
        e.preventDefault();
        e.stopPropagation();
        closeSpecEditor();
        return;
      }

      // 구매처 모달이 열려 있으면 그걸 우선 닫기
      if (supModal.open) {
        e.preventDefault();
        e.stopPropagation();
        setSupModal({ open: false, name: "", address: "", description: "" });
        return;
      }

      // 도크가 열려 있으면 닫기
      if (selected) {
        e.preventDefault();
        setSelected(null);
        setQty("");
        setSupplierName("");
        setUnitPrice("");
        setMsg("");
        document.activeElement?.blur?.();
        setTimeout(() => searchInputRef.current?.focus?.(), 50);
        return;
      }

      // 신규추가 카드가 열려 있으면 닫기
      if (addOpen) {
        e.preventDefault();
        setSupplierName("");
        setUnitPrice("");
        setAddOpen(false);
      }
    };

    window.addEventListener("keydown", onEsc, true);
    return () => window.removeEventListener("keydown", onEsc, true);
  }, [similarOpen, specOpen, supModal.open, addOpen, selected, closeSpecEditor]);

  // ───────── 엑셀 품목 추가 ─────────
  const downloadStockInTemplate = async () => {
  // 컬럼 헤더 순서
    const headers = [
      "Major",
      "Sub",
      "Model",
      "Package",
      "Option",
      "Spec",
      "Description",
      "Stock",
      // "Zone", 로케이션은 선택되면 zone은 어차피 하나임
      "Location",
      "Section",
      "State",
      "Supplier",
      "Price",
    ];

    // 첫 행에 샘플/설명 넣어서 사용자에게 가이드 줄 수도 있음
    const firstRow = {
      Major: "(DB - Categories) 대분류",
      Sub: "(DB - Categories) 소분류",
      Model: "품명",
      Package: "(DB - Packages) 패키지",
      Option: "(옵션) 핀수/사이즈 등",
      Spec: "(옵션) 스펙 - JSON",
      Description: "(옵션) 설명",
      Stock: "입고 수량",
      // Zone: "(DB Lookup) 구역",
      Location: "(DB - Locations) 컨테이너",
      Section: "(DB - Locations) 섹션",
      State: "(DB - States) 상태",
      Supplier: "(DB - Suppliers) 구매처",
      Price: "단가",
    };
    const secondRow = {
      Sub: "※ DB Lookup 은 해당 DB 조회하여 정확하게 입력 할 것",
    };
    const thirdRow = {
      Sub: "※ 입고 수량이 0이 아닐 경우 Supplier, Price 필수 입력 할 것",
    };

    const addSheetFromColumns = (wb, sheetName, rows, columns) => {
      const aoa = [
        columns.map((c) => c.title),
        ...(rows || []).map((r) => columns.map((c) => (r?.[c.key] ?? ""))),
      ];
      const ws = XLSX.utils.aoa_to_sheet(aoa);
      XLSX.utils.book_append_sheet(wb, ws, sheetName);
    };

    try {
      const lookups = await apiFetch("/api/database/template/", { method: "GET" });

      const wb = XLSX.utils.book_new();

      const templateWs = XLSX.utils.json_to_sheet(
        [firstRow, "", secondRow, thirdRow],
        { header: headers }
      );
      templateWs["!cols"] = headers.map(() => ({ wch: 20 }));
      XLSX.utils.book_append_sheet(wb, templateWs, "StockInTemplate");

      // addSheetFromColumns(
      //   wb,
      //   "Majors",
      //   lookups?.majors,
      //   [
      //     // { key: "code", title: "Code" },
      //     { key: "name", title: "Name" },
      //   ]
      // );

      addSheetFromColumns(
        wb,
        "Categories",
        lookups?.subs,
        [
          { key: "major_name", title: "대분류" },
          // { key: "code", title: "Code" },
          { key: "name", title: "소분류" },
          { key: "spec", title: "스펙키" },
        ]
      );

      addSheetFromColumns(
        wb,
        "Packages",
        lookups?.major_packages,
        [
          // { key: "type", title: "Type" },
          { key: "name", title: "패키지" },
          { key: "alias_name", title: "Alias" },
        ]
      );

      // addSheetFromColumns(
      //   wb,
      //   "Packages",
      //   lookups?.packages,
      //   [
      //     { key: "major_package_name", title: "MajorPackage" },
      //     { key: "option", title: "Option" },
      //   ]
      // );

      addSheetFromColumns(
        wb,
        "Locations",
        lookups?.locations,
        [
          // { key: "barcode", title: "Barcode" },
          { key: "major_name", title: "구역" },
          // { key: "container_code", title: "ContainerCode" },
          { key: "container_name", title: "컨테이너" },
          { key: "slot", title: "섹션" },
        ]
      );

      addSheetFromColumns(
        wb,
        "States",
        lookups?.states,
        [{ key: "name", title: "상태" }]
      );

      addSheetFromColumns(
        wb,
        "Suppliers",
        lookups?.suppliers,
        [{ key: "name", title: "구매처" }]
      );

      XLSX.writeFile(wb, "StockInTemplate.xlsx");
    } catch (e) {
      alert(`템플릿 다운로드 실패 : ${e?.message || "알 수 없는 오류"}`);
    }
  };


  //spec error func
  const normalizeText = (s) => String(s || "").replace(/\s+/g, "").trim().toLowerCase();
  const parseBoolLike = (v) => {
    if (v === true || v === false) return true;
    const s = String(v ?? "").trim().toLowerCase();
    return ["1", "0", "true", "false", "y", "n", "yes", "no", "on", "off"].includes(s);
  };

  const isFractionLike = (v) => {
    const s = String(v ?? "").trim();
    if (!s) return false;
    if (!/^[+-]?\d+\s*\/\s*\d+$/.test(s)) return false;

    const [a, b] = s.split("/").map(x => Number(String(x).trim()));
    if (!Number.isFinite(a) || !Number.isFinite(b) || b === 0) return false;

    return true;
  };

  const isDecimalLike = (v) => {
    const s = String(v ?? "").trim();
    if (!s) return false;
    return !Number.isNaN(Number(s));
  };

  const isIntLike = (v) => {
    const s = String(v ?? "").trim();
    if (!s) return false;
    return /^[-+]?\d+$/.test(s);
  };

  const getRowSpecGroup = (row) => {
    const catId = String(row.__categoryId || "").trim();
    if (!catId) return "";

    const cat = catList.find(c => String(c.id) === catId);
    return String(cat?.spec || "").trim().toUpperCase();
  };

  const validateSpecByMeta = (row) => {
    const raw = String(row.Spec ?? "").trim();
    if (!raw) return false;

    let parsed;
    try {
      parsed = JSON.parse(raw);
    } catch {
      return true;
    }

    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
      return true;
    }

    const group = getRowSpecGroup(row);
    if (!group) return true;

    const fields = specMeta?.groups?.[group]?.fields || {};
    if (!Object.keys(fields).length) return true;

    for (const [key, value] of Object.entries(parsed)) {
      const def = fields[key];
      if (!def) {
        return true;
      }

      if (def.multi === true) {
        const sep = def.sep || "|";
        const parts = String(value ?? "")
          .split(sep)
          .map(v => String(v).trim())
          .filter(Boolean);

        if (parts.length === 0) {
          return true;
        }

        if (def.type === "choice") {
          const allowed = new Set((def.choices || []).map(c => String(c.value)));
          if (parts.some(v => !allowed.has(String(v)))) {
            return true;
          }
        }
        continue;
      }

      if (def.type === "decimal") {
        if (key === "watt") {
          if (!isDecimalLike(value) && !isFractionLike(value)) return true;
        } else {
          if (!isDecimalLike(value)) return true;
        }
        continue;
      }

      if (def.type === "int") {
        if (!isIntLike(value)) return true;
        continue;
      }

      if (def.type === "bool") {
        if (!parseBoolLike(value)) return true;
        continue;
      }

      if (def.type === "choice") {
        const allowed = new Set((def.choices || []).map(c => String(c.value)));
        if (!allowed.has(String(value))) return true;
        continue;
      }

      if (def.type === "string") {
        if (!String(value ?? "").trim()) return true;
      }
    }

    return false;
  };

  const REQUIRED_BASE_FIELDS = ["Major", "Sub", "Model", "Package", "Location", "State"];
  const isCellError = (row, field) => {
    const v = String(row[field] ?? "").trim();

    if (field === "Major" || field === "Sub") {
      // 1) __categoryId 가 있고, catList 안에 존재하면 OK
      if (row.__categoryId) {
        const has = catList.some(c => String(c.id) === String(row.__categoryId));
        return !has;
      }

      // 2) id가 없으면 Major + Sub 문자열로 매칭 시도
      const major = (row.Major || "").trim();
      const sub = (row.Sub || "").trim();
      if (!major || !sub) return true;

      const norm = (s) => String(s || "").replace(/\s+/g, "").toLowerCase();

      const cat = catList.find(
        (c) =>
          norm(c.major_name) === norm(major) &&
          norm(c.name) === norm(sub)
      );

      return !cat;
    }

    // if (field === "Spec") {
    //   const t = String(row.Spec ?? "").trim()
    //   if (!t) return false // 빈값 허용(에러 아님). 빈값도 에러로 하려면 true로 바꾸세요.
    //   try {
    //     const v = JSON.parse(t)
    //     return !(v !== null && typeof v === "object")
    //   } catch {
    //     return true
    //   }
    // }

    if (field === "Spec") {
      const raw = String(row.Spec ?? "").trim();
      if (!raw) return false;

      if (!specMeta?.groups) return false;

      const group = getRowSpecGroup(row);
      if (!group) return true;

      return validateSpecByMeta(row);
    }

    // ▒ 위치: Location + Section 합쳐서 검사 ▒
    if (field === "Location") {
      const fullLoc = `${row.__locText}`.trim();
      if (!fullLoc) return true;

      const norm = (s) => String(s || "").replace(/\s+/g, "").toLowerCase();

      const has = locList.some((l) => {
        const half = norm(l.name_half);
        const full = norm(l.name_full);
        const input = norm(fullLoc);
        return half === input || full === input;
      });
      return !has;
    }

    if (field === "Package") {
      // ✅ 1순위: id 기준 검사
      if (row.__packageId) {
        const has = majorPkgList.some(
          (m) => String(m.id) === String(row.__packageId)
        );
        return !has;
      }

      // ✅ 2순위: 그래도 id 없으면 label로 대충 매칭
      const raw = String(row.Package ?? "").trim();
      if (!raw) return true;

      const key = raw.toLowerCase();
      const has = majorPkgList.some((m) => {
        const name = String(m.name ?? "").trim().toLowerCase();
        return name === key;
      });

      return !has;
    }

    if (field === "State") {
      const raw = String(row.State ?? "");
      const key = raw.trim().toLowerCase();
      const has = stateOptions.some((m) => {
        const name = String(m.name ?? "").trim().toLowerCase();
        return name === key
      });

      return !has;
    }
    if (field === "Supplier") {
      const stockNum = Number(row.Stock || 0) || 0;
      if (stockNum === 0) return false;

      const raw = String(row.Supplier ?? "");
      const key = raw.trim().toLowerCase();
      const has = supplierList.some((m) => {
        const name = String(m.name ?? "").trim().toLowerCase();
        return name === key
      });

      return !has;
    }

    if (field === "Stock") {
      const stockNum = Number(row.Stock || 0) || 0;
      const supplierKey = String(row.Supplier ?? "").trim();

      if (supplierKey && stockNum === 0) return true;
      return false;
    }

    // ▒ 기본 필수 항목 (Major, Sub, Model, Package, State 등) ▒
    if (REQUIRED_BASE_FIELDS.includes(field) && !v) return true;

    const stockNum = Number(row.Stock || 0) || 0;
    const supplierKey = String(row.Supplier || "").trim();
    const isStockRegisterSupplier = supplierKey === "재고등록";

    // ▒ 재고가 0 초과일 때 Supplier / Price 필수 ▒
    // 재고등록일경우 단가는 0가능
    if (stockNum > 0 && field === "Supplier") {
      if (!supplierKey) return true;
    }

    if (stockNum > 0 && field === "Price") {
      const priceNum = Number(row.Price || 0);

      if (isStockRegisterSupplier) {
        return !Number.isFinite(priceNum) || priceNum < 0;
      }

      return !Number.isFinite(priceNum) || priceNum <= 0;
    }

    return false;
  };
  
  const excelHasError =
    excelRows.length > 0 &&
    excelRows.some((row) => {
      return (
        isCellError(row, "Major") ||
        isCellError(row, "Sub") ||
        isCellError(row, "Model") ||
        isCellError(row, "Package") ||
        isCellError(row, "Spec") ||
        isCellError(row, "Location") ||
        isCellError(row, "State") ||
        isCellError(row, "Stock") ||
        isCellError(row, "Supplier") ||
        isCellError(row, "Price")
      );
    });
    
  const cancelExcelMode = () => {
    setExcelMode(false);
    setExcelRows([]);
    setExcelFuzzyMap({})
  };

  const fetchExcelSubPkgs = async (majorId) => {
    const id = String(majorId || "").trim()
    if (!id) return
    if (excelSubPkgMap[id]) return

    try {
      const j = await apiFetch(`/api/product/by-major/${id}/`, { cache: "no-store" })
      const opts = Array.isArray(j?.options) ? j.options : []
      setExcelSubPkgMap(prev => ({ ...prev, [id]: opts }))
    } catch {
      setExcelSubPkgMap(prev => ({ ...prev, [id]: [] }))
    }
  }

  const buildCategoryId = (row) => {
    // ✅ 이미 enrichWithExistingProducts 가 DB category 를 넣어둔 경우 우선 사용
    if (row.__categoryId) {
      return Number(row.__categoryId);
    }

    const norm = (s) => String(s || "").replace(/\s+/g, "").toLowerCase();
    const major = (row.Major || "").trim();
    const sub = (row.Sub || "").trim();
    if (!major || !sub) return null;

    const hit = catList.find(
      (c) =>
        norm(c.major_name) === norm(major) &&
        norm(c.name) === norm(sub)
    );
    return hit ? Number(hit.id) : null;
  };

  const buildLocationId = (row) => {
    const full = `${row.__locText || ""}`.trim();
    if (!full) return null;
    const norm = (s) => String(s || "").replace(/\s+/g, "").toLowerCase();
    const hit = locList.find((l) => {
      const v = norm(full);
      return norm(l.name_half) === v || norm(l.name_full) === v;
    });
    return hit ? Number(hit.id) : null;
  };

  const buildStateId = (row) => {
    const key = String(row.State || "").trim().toLowerCase();
    if (!key) return null;
    const hit = stateOptions.find(s => String(s.name || "").trim().toLowerCase() === key);
    return hit ? Number(hit.id) : null;
  };

  const buildPackageInfo = (row) => {
    // __packageId 는 "메이저 패키지 id" 로 쓰고 있으므로
    // → major_package_id 로 넘겨야 함
    if (row.__packageId) {
      return {
        package_id: null,
        major_package_id: row.__packageId,
        // 엑셀의 Option(핀수/사이즈 등)을 서브 패키지 free text 로 사용
        package_free_text: row.Option || null,
      };
    }

    // row.Package 에는 "1005", "SOP-8" 같은 메이저 이름이 들어있다고 가정
    const key = String(row.Package || "").trim().toLowerCase();
    if (!key) {
      return { package_id: null, major_package_id: null, package_free_text: null };
    }

    const hit = majorPkgList.find(
      (m) => String(m.name || "").trim().toLowerCase() === key
    );

    if (hit) {
      // 메이저 패키지만 매칭 → major_package_id + free text(Option)
      return {
        package_id: null,
        major_package_id: hit.id,
        package_free_text: row.Option || null,
      };
    }

    // 메이저 패키지 이름도 못 찾으면: 그냥 사용자가 쓴 텍스트로 넘김
    // (백엔드가 알아서 처리하게)
    return {
      package_id: null,
      major_package_id: null,
      package_free_text: row.Package || null,
    };
  };

  const downloadExcelResult = (rowsOverride) => {
    const rows = rowsOverride ?? excelRows;

    if (!rows || rows.length === 0) {
      alert("다운로드할 엑셀 데이터가 없습니다.");
      return;
    }

    const exportRows = rows.map((row) => {
      const base = {
        Major: row.Major,
        Sub: row.Sub,
        Model: row.Model,
        Package: row.Package,
        Option: row.Option,
        Spec: row.Spec,
        Description: row.Description,
        Stock: row.Stock,
        Zone: row.Zone,
        Location: row.Location,
        Section: row.Section,
        State: row.State,
        Supplier: row.Supplier,
        Price: row.Price,
      };

      let result = "";
      if (row.__uploadDone) {
        result = String(row.__uploadMsg);
      }

      return {
        ...base,
        UploadResult: result,
      };
    });

    const ws = XLSX.utils.json_to_sheet(exportRows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "StockInResult");

    const d = new Date();
    const pad = (n) => String(n).padStart(2, "0");
    const ts = `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}_${pad(d.getHours())}${pad(d.getMinutes())}${pad(d.getSeconds())}`;

    XLSX.writeFile(wb, `StockInResult_${ts}.xlsx`);
  };

  const handleExcelUpload = async () => {
    if (excelHasError || excelRows.length === 0) {
      alert("엑셀 데이터에 오류가 있거나 데이터가 없습니다.");
      return;
    }

    if (!ensureLabelProfile(`${excelRows.length}개 품목을 업로드 하시겠습니까?`)) {
      return;
    }

    setUploadedBarcodes([]);
    setExcelUploading(true);
    setLoading(true);

    try {
      const processedRows = [];

      for (const row of excelRows) {
        const normalizedModel = normalizeModelName(row.Model);

        const category_id = buildCategoryId(row);
        const location_id = buildLocationId(row);
        const state_id = buildStateId(row);
        const { package_id, major_package_id, package_free_text } = buildPackageInfo(row);

        const stockNum = Number(row.Stock || 0) || 0;

        const payload = {
          name: normalizedModel,
          spec: (row.Spec || "").trim(),
          description: (row.Description || "").trim(),
          category_id,
          package_id,
          major_package_id,
          package_free_text,
          location_id,
          state_id,
          username,
          initial_qty: stockNum,
          supplier_name: (row.Supplier || "").trim() || null,
          price: Number(row.Price || 0) || 0,
          existing: !!row.__existing,
        };

        let nextRow = { ...row };

        try {
          const j = await apiFetch("/api/product/create/", {
            method: "POST",
            body: payload,
          });

          nextRow.Zone = j?.inventory_row?.location__major__name || "";
          nextRow.Location = j?.inventory_row?.location__container__name || "";
          nextRow.Section = j?.inventory_row?.location__name || "";
          nextRow.__uploadDone = true;
          nextRow.__uploadOk = true;
          let baseMsg = "";

          if (j?.updated_only) {
            nextRow.__uploadWarn = true;
            baseMsg = j?.message || "부분 성공";
          } else {
            nextRow.product_barcode = j?.inventory_row?.barcode || "";
            baseMsg = "성공: 신규 품목 등록 완료.";
          }

          const productId = j?.inventory_row?.product_id;

          if (productId && stockNum > 0 && payload.supplier_name && payload.price > 0) {
            try {
              await recordPurchase(productId, stockNum, payload.supplier_name, payload.price);
              nextRow.__uploadMsg = baseMsg;
            } catch {
              nextRow.__uploadWarn = true;
              nextRow.__uploadMsg = `${baseMsg} (구매 이력 기록 실패)`;
            }
          }
          else {
            nextRow.__uploadWarn = true;
            nextRow.__uploadMsg = `${baseMsg} (구매 이력 기록 조건 미충족)`;
          }
        } catch (e) {
          nextRow.Zone = "";
          nextRow.__uploadDone = true;
          nextRow.__uploadOk = false;
          nextRow.__uploadMsg = e?.message || "실패: 알 수 없는 오류.";
        }

        processedRows.push(nextRow);
      }

      setExcelRows(processedRows);
      downloadExcelResult(processedRows);

      try {
        const data = await apiFetch("/api/inventory/", { cache: "no-store" });
        const arr = Array.isArray(data?.data) ? data.data : [];
        setItems(arr);
      } catch (e) {
        alert(`재고 재로드 에러 : ${e?.message || "알 수 없는 오류"}`);
      }

      alert("엑셀 업로드 처리가 완료되었습니다.\n결과 데이터를 다운로드 했습니다.");
      const barcodes = processedRows
        .map((r) => String(r?.product_barcode || "").trim())
        .filter(Boolean);

      await confirmBarcodeBulkPrint(barcodes);
    } finally {
      setLoading(false);
      setExcelUploading(false);
    }
  };
  
  const enrichWithExistingProducts = async (rows) => {
    const out = [];

    for (const r of rows) {
      const name = String(r.Model || "").trim();
      if (!name) {
        out.push(r);
        continue;
      }

      try {
        const qs = new URLSearchParams({ name });
        const j = await apiFetch(`/api/product/lookup/?${qs.toString()}`, {
          cache: "no-store",
        });

        const pkgOption = stripMajorPrefix(j.package_label, j.major_package_name) || "";

        const state = String(r.State || "").trim();
        let locText = r.__locText;
        let locLock = false;

        if (state) {
          try {
            const qs2 = new URLSearchParams({ productname: name, state });
            const loc = await apiFetch(`/api/inventory/lookup/?${qs2.toString()}`, {
              method: "GET",
              cache: "no-store",
            });

            if (loc?.exists && loc?.name_full) {
              locText = loc.name_full;
              locLock = true;
            }
          } catch {
          }
        }

        out.push({
          ...r,
          __existing: true,

          Spec: (typeof j.spec === "string" ? j.spec : JSON.stringify(j.spec ?? {})),
          Description: String(j.description ?? ""),
          Option: pkgOption,

          __categoryId: j.category_id,
          __packageId: j.major_package_id,

          __catText: `${j.major_category_name || r.Major || ""} / ${j.category_name || r.Sub || ""}`.trim(),
          __pkgText: String(j.major_package_name || r.Package || "").trim(),
          __locText: String(locText || "").trim(),
          __locLock: locLock,
        });
      } catch {
        out.push(r);
      }
    }

    return out;
  };

  const handleExcelClick = () => {
    if (excelFileRef.current) {
      excelFileRef.current.value = "";
      excelFileRef.current.click();
    }
  };

  const handleExcelFile = async (e) => {
    setSearchTerm("");

    const file = e.target.files?.[0];
    if (!file) return;
    setExcelLoading(true);
    try {
      setLoading(true);
      if (!initLoaded) {
        try {
          const j = await apiFetch("/api/product/quick-list/", { cache: "no-store" });
          setCatList(j?.categories || []);
          setMajorPkgList(j?.major_packages || []);
          setLocList(j?.locations || []);
          setInitLoaded(true);
        } catch {
          // 무시
        }
      }
      
      const buf = await file.arrayBuffer();
      const wb = XLSX.read(buf, { type: "array" });
      const ws = wb.Sheets[wb.SheetNames[0]];
      let rows = XLSX.utils.sheet_to_json(ws, { defval: "" });

      const data_first = rows[0] || {};
      const data_cols = Object.keys(data_first);
      const data_firstCol = (data_cols[0] || "").trim();

      const isValidFormat =
        (data_cols.length === 13 || data_cols.length === 8 || data_cols.length === 11) &&
        (data_firstCol === "Major" || data_firstCol === "NO" || data_firstCol === "No");

      // console.log(data_cols.length, data_firstCol);

      if (!isValidFormat) {
        const ok = window.confirm("지원하지 않는 엑셀 형식입니다. 기본 양식을 다운로드 하시겠습니까?.");
        if (ok) downloadStockInTemplate();
        return;
      }

      const secondRow = rows[0];
      if (secondRow) {
        const hasExample = Object.values(secondRow).some((v) => {
          const s = String(v || "").trim();
          return s.includes("(DB");
        });

        if (hasExample) {
          alert(
            "엑셀 양식의 예시 데이터를 삭제한 후 다시 업로드해 주세요."
          );
          return;
        }
      }

      const first = rows[0] || {}
      const cols = Object.keys(first)

      const norm = (s) => String(s ?? "").trim().toLowerCase()
      const colMap = new Map(cols.map((c) => [norm(c), c]))

      const pickKey = (names) => {
        for (const n of names) {
          const real = colMap.get(norm(n))
          if (real) return real
        }
        return null
      }

      const kModel = pickKey(["품명/규격", "상품명"])
      const kQty = pickKey(["수량", "구매수량"])
      const kPrice = pickKey(["단가"])

      const isAltFormat = !!(kModel && kQty && kPrice)

      // 컬럼 이름 정규화
      rows = rows.map((r, idx) => {
        if (isAltFormat) {
          // ▒ 엘레파츠 포맷: NO, 품명/규격, 수량, 단가, 공급가액, 세액 ▒
          const rawModel = r[kModel] ?? ""
          const rawQty = r[kQty] ?? ""
          const rawPrice = r[kPrice] ?? ""

          // Stock 기본값 + 음수 방지
          let stockStr = String(rawQty).trim();
          if (!stockStr) stockStr = "0";

          // 쉼표 포함될 수도 있으니 제거
          let stockNum = Number(stockStr.replace(/,/g, ""));
          if (!Number.isFinite(stockNum) || stockNum < 0) {
            stockNum = 0;
          }

          const cleanMoney = (v) =>
            String(v ?? "")
              .trim()
              .replace(/[,\s]/g, "")
              .replace(/[원₩]/g, "")

          let priceNum = Number(cleanMoney(rawPrice))
          if (!Number.isFinite(priceNum) || priceNum < 0) {
            priceNum = 0
          }

          return {
            __id: idx + 1,

            // 카테고리/위치는 비워둠
            Major: "",
            Sub: "",

            // 품명/규격 → Model
            Model: String(rawModel || "").trim(),

            // 나머지는 기본값
            Package: "",
            Option: "",
            Spec: "",
            Description: "",

            // 수량 → Stock
            Stock: String(stockNum),

            Location: "",
            Section: "",

            // 상태/구매처 고정
            State: "신품",
            Supplier: "엘레파츠",

            // 단가 그대로 문자열로 보관 (나중에 Number(row.Price || 0)에서 숫자로 변환)
            Price: String(priceNum),

            __categoryId: null,
            __packageId: null,
          };
        }
        
        // ▒ Stock 기본값 0 처리 ▒
        const rawStock = r.Stock ?? "";
        let stockStr = String(rawStock).trim();
        if (!stockStr) stockStr = "0";

        let stockNum = Number(stockStr);
        if (!Number.isFinite(stockNum) || stockNum < 0) stockNum = 0;

        return {
          __id: idx + 1,
          Major: String(r.Major ?? "").trim(),
          Sub: String(r.Sub ?? "").trim(),
          Model: String(r.Model ?? "").trim(),
          Package: String(r.Package ?? "").trim(),
          Option: String(r.Option ?? "").trim(),
          Spec: String(r.Spec ?? "").trim(),
          Description: String(r.Description ?? "").trim(),
          Stock: String(stockNum),
          Location: "",
          Section: "",
          State: String(r.State ?? "").trim(),
          Supplier: String(r.Supplier ?? "").trim(),
          Price: String(r.Price ?? "").trim(),

          __catText: `${String(r.Major ?? "").trim()} / ${String(r.Sub ?? "").trim()}`.trim(),
          __pkgText: String(r.Package ?? "").trim(),
          __locText: `${String(r.Location ?? "").trim()}${String(r.Section ?? "").trim() ? "-" + String(r.Section ?? "").trim() : ""}`.trim(),
          __optText: String(r.Option ?? "").trim(),
          __categoryId: null,
          __packageId: null,
          __specGroup: "",
        };
      });

      // 기존 품목이면 DB 기준으로 덮어쓰기
      const enriched = await enrichWithExistingProducts(rows);


      // ✅ 여기부터 추가: 패키지 텍스트 → __packageId 강제 매칭 + 옵션 미리 로드
      const n = (s) => String(s || "")
        .replace(/\s+/g, "")
        .replace(/[-_]/g, "")
        .toLowerCase()

      const fixed = enriched.map((r) => {
        if (r.__packageId) return r

        const raw = String(r.__pkgText ?? r.Package ?? "").trim()
        if (!raw) return r

        const hit = majorPkgList.find((m) => {
          const nameOk = n(m.name) === n(raw)
          const aliasOk = String(m.alias_name || "")
            .split(/[,\|\/;]/g)
            .map((x) => n(x))
            .filter(Boolean)
            .includes(n(raw))
          return nameOk || aliasOk
        })

        if (!hit) return r

        return {
          ...r,
          __packageId: hit.id,
          __pkgText: hit.name || raw,
          Package: hit.name || raw,
          __optText: String(r.Option || "").trim()
        }
      })

      const syncExcelCategoryIds = (rows) => {
        if (!Array.isArray(rows) || rows.length === 0) return rows
        if (!Array.isArray(catList) || catList.length === 0) return rows

        const norm = (s) => String(s || "").replace(/\s+/g, "").toLowerCase()

        return rows.map((r) => {
          if (r.__categoryId) return r

          const major = String(r.Major || "").trim()
          const sub = String(r.Sub || "").trim()
          if (!major || !sub) return r

          const hit = catList.find((c) =>
            norm(c.major_name) === norm(major) && norm(c.name) === norm(sub)
          )
          if (!hit) return r

          return {
            ...r,
            __categoryId: hit.id,
            __catText: `${hit.major_name} / ${hit.name}`,
            Major: hit.major_name || r.Major,
            Sub: hit.name || r.Sub,
          }
        })
      }

      // 메이저 패키지별 서브옵션 미리 캐시
      Array.from(new Set(
        fixed
          .map((r) => String(r.__packageId || "").trim())
          .filter(Boolean)
      )).forEach((id) => {
        fetchExcelSubPkgs(id)
      })

      const synced = syncExcelCategoryIds(fixed)
      setExcelRows(synced)
      synced.forEach((r) => {
        if (r.__existing) return
        const name = String(r.Model || "").trim()
        if (!name) return
        scheduleSimilarForRow(r.__id, name)
      })
      setExcelFuzzyMap({})
      setExcelMode(true)
      setSelected(null)
      setSearchTerm("")
      setFiltered([])
    } catch (err) {
      alert("엑셀 파일 읽기 중 오류: " + (err?.message || String(err)));
    } finally {
      setExcelLoading(false);
      setLoading(false);
    }
  };

  const ensureLabelProfile = (message = null) => {
    if (!labelProfile) {
      alert("프린터 프로필이 준비되지 않았습니다.");
      return false;
    }

    if (message) {
      return window.confirm(`라벨 프린터 ${labelProfile}으로 진행합니다.\n${message}`);
    }
  };

  const printLabels = async ({ items, data, qty = 1} = {}) => {
    const health = await apiFetch("/api/print/label/health/", { method: "GET" });

    if (!health?.ok) {
      const d = health?.service?.details || {};
      const errors = [];
      if (d.font === false) errors.push("폰트 없음");
      if (d.logo === false) errors.push("로고 없음");
      if (d.printer === false) errors.push("프린터 없음");

      const msg = errors.length > 0 ? errors.join(" / ") : "프린터 연결 실패";
      throw new Error(msg);
    }

    let arr = items;

    if (!Array.isArray(arr)) {
      if (!data) throw new Error("출력 데이터가 없습니다.");
      arr = [{ data, qty }];
    }

    if (arr.length === 0) throw new Error("출력 데이터가 없습니다.");

    const username = localStorage.getItem("username") || "";

    const j = await apiFetch("/api/print/label/text/", {
      method: "POST",
      body: {
        profile: labelProfile,
        username,
        data: arr.map((v) => {
          if (typeof v === "string") {
            return v;
          }
          return (v.data ?? v.text ?? "").toString().trim();
        }).filter(Boolean),
        qty,
      },
    });

    if (!j?.ok) throw new Error(j?.error || "인쇄 API 호출 실패");
    // if ((j.failed ?? 0) > 0) throw new Error(j?.errors?.[0]?.error || "일부 인쇄 실패");
    return j;
  };

  const confirmAndPrint = async (name, label) => {
    if (!window.confirm(`${name} 바코드를 출력 하시겠습니까?`)) return;

    try {
      await printLabels({
        data: label,
        qty: 1,
      });
      alert("✅ 라벨 인쇄 요청을 보냈습니다.");
    } catch (e) {
      alert(`인쇄 실패: ${e.message || e}`);
    }
  };

  const confirmBarcodeBulkPrint = async (barcodes) => {
    const list = (barcodes || [])
      .map((bc) => String(bc || "").trim())
      .filter(Boolean)
      .map((bc) => ({ data: bc, qty: 1 }));

    const kinds = list.length;

    if (kinds === 0) return;

    if (!window.confirm(`업로드된 바코드 ${kinds}개를 연속 출력합니다.\n출력 하시겠습니까?`)) {
      return;
    }

    try {
      const j = await printLabels({
        items: list,
        qty: 1,
      });

      alert(`모든 라벨 인쇄 요청이 완료되었습니다.\n성공: ${j.total} 항목`);
    } catch (e) {
      alert(`바코드 일괄 인쇄 실패\n${e?.message || e}`);
    } finally {
    }
  };

  // 퍼지매칭
  const excelFuzzyTimersRef = useRef(new Map())
  const excelFuzzyCtrlRef = useRef(new Map())

  const fetchSimilar = async (name) => {
    const q = String(name || "").trim()
    if (!q) {
      setSimilarBest(null)
      setSimilarList([])
      return
    }

    setSimilarLoading(true)
    try {
      const qs = new URLSearchParams({ name: q })
      const j = await apiFetch(`/api/product/similar/?${qs.toString()}`, {
        method: "GET",
        cache: "no-store",
      })

      if (!j?.ok) {
        setSimilarBest(null)
        setSimilarList([])
        return
      }

      setSimilarBest(Number(j.best_score ?? 0))
      setSimilarList(Array.isArray(j.items) ? j.items : [])
    } catch {
      setSimilarBest(null)
      setSimilarList([])
    } finally {
      setSimilarLoading(false)
    }
  }

  const applySimilarToAddForm = (p) => {
    if (!p) return

    // 모달 닫고, 선택한 품명으로 교체
    // -> 기존 useEffect([newName]) 룩업이 자동으로 돌면서 폼 자동 채움
    setSimilarOpen(false)

    const nextName = String(p.name || "").trim()
    if (nextName) setNewName(nextName)

    // 유사 API 응답에 description/spec가 있으면 미리 채워도 됨(없으면 룩업이 채움)
    if (p.description) setDescText(String(p.description || ""))
    if (p.spec) setNewValue(typeof p.spec === "string" ? p.spec : JSON.stringify(p.spec || {}))
  }

  const fetchSimilarExcel = async (name) => {
    const q = String(name || "").trim()
    if (!q) {
      setExcelSimilarBest(null)
      setExcelSimilarList([])
      return
    }

    setExcelSimilarLoading(true)
    try {
      const qs = new URLSearchParams({ name: q })
      const j = await apiFetch(`/api/product/similar/?${qs.toString()}`, {
        method: "GET",
        cache: "no-store",
      })

      if (!j?.ok) {
        setExcelSimilarBest(null)
        setExcelSimilarList([])
        return
      }

      setExcelSimilarBest(Number(j.best_score ?? 0))
      setExcelSimilarList(Array.isArray(j.items) ? j.items : [])
    } catch {
      setExcelSimilarBest(null)
      setExcelSimilarList([])
    } finally {
      setExcelSimilarLoading(false)
    }
  }

  const openExcelSimilar = async (row) => {
    const q = String(row?.Model || "").trim()
    if (!q) return

    setExcelSimilarTarget({ rowId: row.__id, query: q })
    setExcelSimilarOpen(true)
    await fetchSimilarExcel(q)
  }

  const applySimilarToExcelRow = (picked) => {
    const rowId = excelSimilarTarget?.rowId
    if (!rowId || !picked) return

    // picked: /api/product/similar/ 에서 내려주는 item 구조에 맞춰 조정
    setExcelRows(prev => prev.map(r => {
      if (r.__id !== rowId) return r

      const pkgOption = stripMajorPrefix(picked.package_label, picked.major_package_name) || ""

      return {
        ...r,

        // 품명/스펙/설명 덮기
        Model: String(picked.name || r.Model || "").trim(),
        Spec: (typeof picked.spec === "string" ? picked.spec : JSON.stringify(picked.spec ?? {})),
        Description: String(picked.description ?? ""),

        // 카테고리/패키지 id 동기화
        __existing: true,
        __categoryId: picked.category_id ?? r.__categoryId ?? null,
        __packageId: picked.major_package_id ?? r.__packageId ?? null,

        // 표시 텍스트 동기화
        Major: picked.major_category_name ?? r.Major ?? "",
        Sub: picked.category_name ?? r.Sub ?? "",
        __catText: `${picked.major_category_name || r.Major || ""} / ${picked.category_name || r.Sub || ""}`.trim(),
        Package: String(picked.major_package_name || r.Package || "").trim(),
        __pkgText: String(picked.major_package_name || r.__pkgText || r.Package || "").trim(),

        // 옵션(서브패키지) 텍스트만 일단 반영
        Option: String(pkgOption || r.Option || "").trim(),
        __optText: String(pkgOption || r.__optText || r.Option || "").trim(),
      }
    }))

    setExcelSimilarOpen(false)
  }

  const fetchSimilarForRow = async (rowId, name) => {
    const q = String(name || "").trim()
    if (!q) {
      setExcelFuzzyMap(prev => {
        const next = { ...prev }
        delete next[rowId]
        return next
      })
      return
    }

    // 이전 요청 중단
    const prevCtrl = excelFuzzyCtrlRef.current.get(rowId)
    if (prevCtrl) prevCtrl.abort()

    const ctrl = new AbortController()
    excelFuzzyCtrlRef.current.set(rowId, ctrl)

    setExcelFuzzyMap(prev => ({
      ...prev,
      [rowId]: {
        ...(prev[rowId] || {}),
        q,
        loading: true,
        best: Number(prev[rowId]?.best ?? 0),
        items: Array.isArray(prev[rowId]?.items) ? prev[rowId].items : [],
      }
    }))

    try {
      const qs = new URLSearchParams({ name: q })
      const j = await apiFetch(`/api/product/similar/?${qs.toString()}`, {
        method: "GET",
        cache: "no-store",
        signal: ctrl.signal,
      })

      if (!j?.ok) {
        setExcelFuzzyMap(prev => ({
          ...prev,
          [rowId]: { ...(prev[rowId] || {}), q, loading: false, best: 0, items: [] }
        }))
        return
      }

      const best = Number(j.best_score ?? 0)
      const items = Array.isArray(j.items) ? j.items : []

      setExcelFuzzyMap(prev => ({
        ...prev,
        [rowId]: { ...(prev[rowId] || {}), q, loading: false, best, items }
      }))
    } catch (e) {
      if (e?.name === "AbortError") return
      setExcelFuzzyMap(prev => ({
        ...prev,
        [rowId]: { ...(prev[rowId] || {}), q, loading: false, best: 0, items: [] }
      }))
    }
  }

  const scheduleSimilarForRow = (rowId, name) => {
    const tmap = excelFuzzyTimersRef.current
    const prev = tmap.get(rowId)
    if (prev) clearTimeout(prev)

    const t = setTimeout(() => {
      fetchSimilarForRow(rowId, name)
    }, 300)

    tmap.set(rowId, t)
  }

  useEffect(() => {
    return () => {
      // 타이머 정리
      for (const t of excelFuzzyTimersRef.current.values()) clearTimeout(t)
      excelFuzzyTimersRef.current.clear()

      // 요청 중단
      for (const c of excelFuzzyCtrlRef.current.values()) c.abort()
      excelFuzzyCtrlRef.current.clear()
    }
  }, [])

  const renderExcelTable = () => {
    if (excelRows.length === 0) {
      return (
        <tr>
          <td colSpan="11" style={{ textAlign: "center", color: "#666" }}>
            엑셀에서 불러온 데이터가 없습니다.
          </td>
        </tr>
      );
    }

    // 드롭박스용 옵션
    const stateNames = stateOptions.map(s => s.name);
    const supplierNames = supplierList.map(s => s.name);

    const updateCell = (rowId, field, value) => {
      setExcelRows(prev =>
        prev.map(r => (r.__id === rowId ? { ...r, [field]: value } : r))
      );
    };

    const handleStateChange = async (rowId, nextState) => {
      const row = excelRows.find(r => r.__id === rowId);
      const productname = (row?.Model || "").trim();

      updateCell(rowId, "State", nextState);

      const state = (nextState || "").trim();
      if (!productname || !state) return;

      setLoading(true);
      updateCell(rowId, "__locLock", true);

      try {
        const qs = new URLSearchParams({ productname, state });

        const j = await apiFetch(`/api/inventory/lookup/?${qs.toString()}`, {
          method: "GET",
          cache: "no-store",
        });

        if (!j?.exists) {
          updateCell(rowId, "__locLock", false);
          return;
        }

        updateCell(rowId, "__locText", j.name_full || "");
      } catch (e) {
        updateCell(rowId, "__locLock", false);
      } finally {
        setLoading(false);
      }
    };

    return excelRows.map((row) => {
      // ─ 카테고리: Major + Sub 합친 드롭박스 ─
      const norm = (s) => String(s || "").replace(/\s+/g, "").toLowerCase();

      let catId = "";

      // 1) id 우선
      if (row.__categoryId) {
        const hit = catList.find(c => String(c.id) === String(row.__categoryId));
        if (hit) {
          catId = String(hit.id);
        }
      }

      // 2) id로 못 찾았으면 Major/Sub 문자열로 찾기
      if (!catId) {
        const cat = catList.find(
          (c) =>
            norm(c.major_name) === norm(row.Major) &&
            norm(c.name) === norm(row.Sub)
        );
        if (cat) {
          catId = String(cat.id);
        }
      }

      const hasCatError = isCellError(row, "Major") || isCellError(row, "Sub");

      // console.log(
      //   "[엑셀 카테고리 매핑]",
      //   "rowId=", row.__id,
      //   "Major/Sub=", row.Major, "/", row.Sub,
      //   "__categoryId=", row.__categoryId,
      //   "dropdownValue(catId)=", catId
      // );

      // ─ 위치: Location + Section 합쳐서 fullLoc 만들기 ─
      const fullLoc = `${row.__locText || ""}`.trim();
      const locMatch = locList.find(
        l => (l.name_full || "").trim().toLowerCase() === fullLoc.toLowerCase()
      );
      const locId = locMatch ? String(locMatch.id) : "";
      const isExistingRow = row.__existing && !(row.__uploadDone && row.__uploadOk && row.__uploadWarn);

      return (
        <tr
          key={row.__id}
          className={[
            isExistingRow ? "excel-existing-row" : "",
            row.__uploadDone && row.__uploadOk === false
              ? "excel-row-fail"
              : row.__uploadWarn
                ? "excel-row-warn"
                : row.__uploadDone && row.__uploadOk === true
                  ? "excel-row-success"
                  : "",
          ].join(" ").trim()}
        >
          {/* 카테고리 (Major + Sub) */}
          <td className={(isCellError(row, "Major") || isCellError(row, "Sub")) ? "cell-error" : ""}>
            <AutocompleteSelect
              value={catId}
              text={row.__catText ?? ""}
              setText={(v) => {
                updateCell(row.__id, "__catText", v);

                const n = (s) => String(s || "").replace(/\s+/g, "").toLowerCase();
                const hit = catList.find((c) => n(`${c.major_name} / ${c.name}`) === n(v));

                if (!hit) {
                  // ✅ 매칭 안 되면 검사용 필드들을 비워서 에러가 반드시 뜨게
                  updateCell(row.__id, "Major", "");
                  updateCell(row.__id, "Sub", "");
                  updateCell(row.__id, "__categoryId", null);
                } else {
                  // ✅ 정확히 매칭되면 id/필드 동기화
                  updateCell(row.__id, "Major", hit.major_name || "");
                  updateCell(row.__id, "Sub", hit.name || "");
                  updateCell(row.__id, "__categoryId", hit.id);
                }
              }}
              options={catList}
              getLabel={(c) => `${c.major_name} / ${c.name}`}
              placeholder="카테고리 입력"
              disabled={row.__existing}
              onSelect={(c) => {
                updateCell(row.__id, "Major", c.major_name || "");
                updateCell(row.__id, "Sub", c.name || "");
                updateCell(row.__id, "__categoryId", c.id);
                updateCell(row.__id, "__catText", `${c.major_name} / ${c.name}`);
              }}
            />
          </td>

          {/* Model */}
          <td className={isCellError(row, "Model") ? "cell-error" : ""}>
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <input
                className="excel-input"
                value={row.Model}
                onChange={(e) => {
                  const v = e.target.value
                  updateCell(row.__id, "Model", v)
                  if (!row.__existing) scheduleSimilarForRow(row.__id, v)
                }}
                disabled={row.__existing}
                style={{ flex: 1 }}
              />

              {(() => {
                const fuzzy = excelFuzzyMap[row.__id]
                const best = Number(fuzzy?.best ?? 0)
                const items = Array.isArray(fuzzy?.items) ? fuzzy.items : []
                const loading = !!fuzzy?.loading

                const showBtn = !row.__existing && !loading && best >= 50 && items.length > 0

                if (!showBtn) return null

                return (
                  <button
                    type="button"
                    className="excel-btn"
                    onClick={() => {
                      setExcelSimilarTarget({ rowId: row.__id, query: row.Model })
                      setExcelSimilarBest(best)
                      setExcelSimilarList(items)
                      setExcelSimilarOpen(true)
                    }}
                    title={`유사 품목 보기 (${best}%)`}
                    style={{
                      padding: "4px 8px",
                      lineHeight: 1,
                      minWidth: 34,
                    }}
                  >
                    🔍
                  </button>
                )
              })()}
            </div>
          </td>

          {/* Package */}
          <td className={isCellError(row, "Package") ? "cell-error" : ""}>
            <AutocompleteSelect
              value={row.__packageId ? String(row.__packageId) : ""}
              text={row.__pkgText ?? row.Package ?? ""}
              setText={(v) => {
                updateCell(row.__id, "__pkgText", v)
                updateCell(row.__id, "Package", v)

                const n = (s) => String(s || "").replace(/\s+/g, "").toLowerCase()
                const hit = majorPkgList.find((m) => {
                  if (n(m.name) === n(v)) return true
                  const aliasOk = String(m.alias_name || "")
                    .split(/[,\|\/;]/g)
                    .map((x) => n(x))
                    .filter(Boolean)
                    .includes(n(v))
                  return aliasOk
                })

                if (!hit) {
                  updateCell(row.__id, "__packageId", null)
                  return
                }

                updateCell(row.__id, "__packageId", hit.id)
                updateCell(row.__id, "__pkgText", hit.name || "")
                updateCell(row.__id, "Package", hit.name || "")
                updateCell(row.__id, "Option", "")
                updateCell(row.__id, "__optText", "")
                fetchExcelSubPkgs(hit.id)
              }}
              options={majorPkgList}
              getLabel={(m) => m.name || ""}
              placeholder="패키지 입력"
              disabled={row.__existing}
              onSelect={(m) => {
                updateCell(row.__id, "__packageId", m.id)
                updateCell(row.__id, "Package", m.name || "")
                updateCell(row.__id, "__pkgText", m.name || "")
                updateCell(row.__id, "Option", "")
                updateCell(row.__id, "__optText", "")
                fetchExcelSubPkgs(m.id)
              }}
            />
          </td>

          {/* Option */}
          <td>
            {(() => {
              const majorId = String(row.__packageId || "").trim()
              const majorName =
                majorPkgList.find(m => String(m.id) === majorId)?.name || ""

              const subOpts = excelSubPkgMap[majorId] || []

              const optionList = subOpts
                .map((p) => {
                  const sub = stripMajorPrefix(p.label, majorName)
                  if (!sub) return null
                  return { id: p.id, label: sub }
                })
                .filter(Boolean)

              return (
                <AutocompleteSelect
                  value={row.__subPackageId ? String(row.__subPackageId) : ""}
                  text={row.__optText ?? row.Option ?? ""}
                  setText={(v) => {
                    updateCell(row.__id, "__optText", v)
                    updateCell(row.__id, "Option", v) // 직접입력 지원
                    updateCell(row.__id, "__subPackageId", null) // 직접입력이면 선택해제
                  }}
                  options={optionList}
                  getLabel={(o) => o.label}
                  placeholder={majorId ? "옵션 입력" : "패키지 선택 필요"}
                  disabled={row.__existing || !majorId}
                  onSelect={(o) => {
                    updateCell(row.__id, "__subPackageId", o.id)
                    updateCell(row.__id, "Option", o.label)
                    updateCell(row.__id, "__optText", o.label)
                  }}
                  onClear={() => {
                    updateCell(row.__id, "__subPackageId", null)
                    updateCell(row.__id, "Option", "")
                    updateCell(row.__id, "__optText", "")
                  }}
                  requireMatch={false}
                />
              )
            })()}
          </td>

          {/* Spec */}
          <td className={isCellError(row, "Spec") ? "cell-error" : ""}>
            <input
              className="excel-input"
              value={row.Spec}
              readOnly
              onClick={() => openSpecEditorExcel(row)}
              onFocus={(e) => {
                e.target.blur()
                openSpecEditorExcel(row)
              }}
              disabled={row.__existing}
              placeholder="클릭하여 스펙 편집"
            />
          </td>

          {/* Description */}
          <td>
            <input
              className="excel-input"
              value={row.Description}
              onChange={(e) => updateCell(row.__id, "Description", e.target.value)}
              disabled={row.__existing} 
            />
          </td>

          {/* Stock */}
          <td className={isCellError(row, "Stock") ? "cell-error" : ""}>
            <input
              className="excel-input"
              type="number"
              value={row.Stock}
              onChange={(e) => {
                let v = e.target.value;
                let n = Number(v);
                if (!Number.isFinite(n) || n < 0) {
                  n = 0;
                }
                updateCell(row.__id, "Stock", String(n));
              }}
            />
          </td>

          {/* 위치 (Location + Section 합쳐서 / 드롭박스) */}
          <td className={isCellError(row, "Location") ? "cell-error" : ""}>
            <AutocompleteSelect
              value={locId}
              text={row.__locText ?? fullLoc}
              setText={(v) => {
                updateCell(row.__id, "__locText", v);
              }}
              options={locList}
              getLabel={(l) => l.name_full || ""}
              placeholder="위치 입력"
              disabled={!!row.__locLock}
              onSelect={(l) => {
                const full = l.name_full || "";
                updateCell(row.__id, "__locText", full);
              }}
            />
          </td>

          {/* State */}
          <td className={isCellError(row, "State") ? "cell-error" : ""}>
            <select
              className="excel-input"
              value={row.State}
              onChange={(e) => handleStateChange(row.__id, e.target.value)}
            >
              <option value="">상태 선택</option>
              {stateNames.map(n => (
                <option key={n} value={n}>{n}</option>
              ))}
            </select>
          </td>

          {/* Supplier */}
          <td className={isCellError(row, "Supplier") ? "cell-error" : ""}>
            <select
              className="excel-input"
              value={row.Supplier}
              onChange={(e) => updateCell(row.__id, "Supplier", e.target.value)}
            >
              <option value="">구매처 선택</option>
              {supplierNames.map(n => (
                <option key={n} value={n}>{n}</option>
              ))}
            </select>
          </td>

          {/* Price */}
          <td className={isCellError(row, "Price") ? "cell-error" : ""}>
            <input
              className="excel-input"
              value={row.Price}
              onChange={(e) => updateCell(row.__id, "Price", e.target.value)}
            />
          </td>

          {/* 결과 */}
          {hasUploadResult && (
            <td>
              {row.__uploadDone ? (
                row.__uploadOk ? (
                  row.__uploadWarn ? (
                    <span>{row.__uploadMsg || "부분 성공"}</span>
                  ) : (
                    <span>✅ 업로드 완료.</span>
                  )
                ) : (
                  <span>{row.__uploadMsg || "업로드 실패"}</span>
                )
              ) : (
                ""
              )}
            </td>
          )}
        </tr>
      );
    });
  };

  // if (loading) return <p>입고 데이터를 불러오는 중...</p>;
  if (error) return <p>에러 발생: {error}</p>;

  return (
    <div className="stockin-page">
      <Loading active={loading} />
      <div className="stockin-header">
        <h1>📥 입고 관리</h1>

        <Scanner ref={scannerRef} onScan={(value) => setSearchTerm(value)} />
        <div className="search-row">
          <input
            type="text"
            ref={searchInputRef}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder='검색: 품명, 스펙, 카테고리, 패키지, 위치 (&, |, !, "" 가능)'
            className="stockin-search"
          />
          {/* <div className="label-profile-badge">
            라벨 프로필: {labelProfile || "미설정"}
          </div> */}
          {excelMode ? (
            <>
              <button className="blue-btn" onClick={cancelExcelMode} disabled={excelUploading}>
                {hasUploadResult ? "뒤로" : "취소"}
              </button>
              <button
                className="blue-btn"
                onClick={handleExcelUpload}
                // disabled={excelHasError || excelRows.length === 0 || excelUploading}
                style={{
                  display: (hasUploadResult) ? "none" : "block",
                }}
              >
                {excelUploading ? "업로드 중..." : `${excelRows.length} 항목 업로드`}
              </button>
            </>
          ) : (
            <>
              {/* <button className="trans-btn icon-text-btn" onClick={openSpecEditor}>
                <span className="btn-icon">🧩</span>
                <span className="btn-text">스펙 편집</span>
              </button> */}
              <button className="trans-btn icon-text-btn" onClick={handleExcelClick}>
                <input
                  type="file"
                  ref={excelFileRef}
                  accept=".xls,.xlsx"
                  style={{ display: "none" }}
                  onChange={handleExcelFile}
                />
                <span className="btn-icon">🗂️</span>
                <span className="btn-text">파일 추가</span>
              </button>
              <button className="trans-btn icon-text-btn" onClick={openAdd}>
                <span className="btn-icon">📥</span>
                <span className="btn-text">단품 추가</span>
              </button>
            </>
          )}
        </div>
      </div>

      {/* ─ 중앙: 테이블(래퍼만 스크롤) ─ */}
      <div className="table-wrap">
        {excelMode ? (
          <table className="inventory-table excel-table">
            <thead>
              <tr>
                <th>카테고리</th>
                <th>품명</th>
                <th>패키지</th>
                <th>패키지 옵션</th>
                <th>스펙</th>
                <th>설명</th>
                <th>입고 수량</th>
                <th>보관 위치</th>
                <th>상태</th>
                <th>구매처</th>
                <th>단가</th>
                {hasUploadResult && <th>결과</th>}
              </tr>
            </thead>
            <tbody>
              {excelLoading ? (
                <tr>
                  <td colSpan={hasUploadResult ? 12 : 11} style={{ textAlign: "center" }}>
                    엑셀 데이터를 불러오는 중...
                  </td>
                </tr>
              ) : (
                renderExcelTable()
              )}
            </tbody>
          </table>
        ) : (
          <table className="inventory-table">
            <thead>
              <tr>
                <th>카테고리</th>
                <th>품명</th>
                <th>패키지</th>
                <th>스펙</th>
                <th>재고</th>
                <th>위치</th>
                <th>상태</th>
              </tr>
            </thead>
            <tbody>
              {/* 목록 있을 때 */}
              {filtered.length > 0 ? (
                filtered.map((it) => (
                  <tr
                    key={it.id}
                    className={selected?.id === it.id ? "row-selected" : ""}
                    onClick={() => setSelected(it)}
                  >
                    <td
                      dangerouslySetInnerHTML={{
                        __html: highlightHTML(
                          `${it.category_display_name || "카테고리 없음"}`
                        ),
                      }}
                    />
                    <td dangerouslySetInnerHTML={{ __html: highlightHTML(it.product__name || it.name || "") }} />
                    <td
                      dangerouslySetInnerHTML={{
                        __html: highlightHTML(
                          `${it.product__package__major_package__name || ""}${
                            it.product__package__option ? `-${it.product__package__option}` : ""
                          }`
                        ),
                      }}
                    />
                    <td
                      dangerouslySetInnerHTML={{
                        __html: highlightHTML(
                          it.product__display_spec !== null && it.product__display_spec !== undefined
                            ? String(it.product__display_spec)
                            : ""
                        ),
                      }}
                    />
                    <td>{it.stock ?? "-"}</td>
                    <td
                      dangerouslySetInnerHTML={{
                        __html: highlightHTML(
                          `${it.location_display_name}`
                        ),
                      }}
                    />
                    <td
                      dangerouslySetInnerHTML={{
                        __html: highlightHTML(
                          `${it.state__name}`
                        ),
                      }}
                    />
                  </tr>
                ))
              ) : (
                /* 기본 안내 행 */
                <tr>
                  <td colSpan="6" style={{ textAlign: "center", color: "#666" }}>
                    {searchTerm.trim() ? "검색 결과 없음" : "검색어를 입력하세요"}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>

      {/* <div className={`form-backdrop ${selected ? "open" : ""}`} /> */}
      {/* ─ 하단 도크: 선택 + 입고 수량 ─ */}
      { addOpen && (
      <div className="inline-add-row">
        <div className="add-card" role="dialog" aria-label="신규 품목 추가">
          <div className="add-card__head">
            <div className="add-card__title">➕ 신규 품목 추가</div>
            <button
              onClick={() => setAddOpen(false)}
              style={{ border: "none", background: "transparent", fontSize: 18, cursor: "pointer"}}
              aria-label="닫기"
              title="닫기"
            >
              ×
            </button>
          </div>

          <div className="add-grid">
            {/* 품명 */}
            <div className="field">
              <div className="field__label">품명</div>

              <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                <input
                  className="field__control highlight"
                  placeholder="예: 74HC595"
                  value={newName}
                  onChange={(e) => setNewName(e.target.value)}
                  style={{ flex: 1 }}
                />

                <div
                  className={`lookup-badge lookup-badge--${lookupStatus}`}
                  aria-label="조회 상태"
                  onClick={() => {
                    if (lookupStatus !== "new") return
                    if (similarLoading) return
                    if (!Array.isArray(similarList) || similarList.length === 0) return
                    setSimilarOpen(true)
                  }}
                  style={{
                    cursor: (lookupStatus === "new" && similarList.length > 0) ? "pointer" : "default",
                    userSelect: "none",
                  }}
                  title={(lookupStatus === "new" && similarList.length > 0) ? "클릭하여 유사 품목 보기" : ""}
                >
                  {lookupStatus === "idle" && "대기"}
                  {lookupStatus === "checking" && "조회중"}
                  {lookupStatus === "exists" && "기존 품목"}
                  {lookupStatus === "new" && (
                    <>
                      신규 품목
                      {typeof similarBest === "number" ? ` (${similarBest}%)` : ""}
                    </>
                  )}
                  {lookupStatus === "error" && "오류"}
                </div>
              </div>
            </div>

            {/* 카테고리 */}
            <div className="field">
              <div className="field__label">카테고리</div>

              <AutocompleteSelect
                value={selCategory}
                text={catText}
                setText={setCatText}
                options={catList}
                getLabel={(c) => `${c.major_name} / ${c.name}`}
                placeholder="예: IC / OPAMP"
                disabled={lockCatPkg}
                lockStyle={!!selCategory}
                onSelect={(c) => {
                  setSelCategory(String(c.id));
                }}
                onClear={() => {
                  setSelCategory("");
                }}
              />
            </div>

            {/* 메이저 패키지 */}
            <div className="field">
              <div className="field__label">메이저 패키지</div>

              <AutocompleteSelect
                value={selMajorPkg}
                text={majorPkgText}
                setText={setMajorPkgText}
                options={majorPkgList}
                getLabel={(m) => m.name || ""}
                placeholder="예: SMD, SOP, DIP..."
                disabled={lockCatPkg}
                lockStyle={!!selMajorPkg}
                onSelect={async (m) => {
                  setSelMajorPkg(String(m.id));
                  setPkgText("");
                  setPkgAuto(false);
                  await fetchPkgOptions(m.id);
                }}
                onClear={() => {
                  setSelMajorPkg("");
                  setPkgText("");
                  setPkgAuto(false);
                }}
              />
            </div>

            {/* 패키지 / 핀수 (입력 또는 선택) */}
            <div className="field">
              <div className="field__label">핀수, 사이즈, 기타옵션 (옵션)</div>

              {/* 옵션이 있으면 드롭다운도 제공 */}
              {pkgOptions?.length > 0 && (
                <select
                  className="field__control"
                  value={pkgText}
                  onChange={(e) => {
                    const v = e.target.value;
                    setPkgText(v);
                    setPkgAuto(!!v);
                  }}
                  disabled={!selMajorPkg || lockCatPkg}
                  style={{
                    display: (!selMajorPkg || lockCatPkg) ? "none" : "block",
                  }}
                >
                  <option value="">
                    {pkgOptions?.length > 0 ? "서브 패키지 미선택 (공란)" : "서브 패키지 없음 (공란)"}
                  </option>
                  {pkgOptions?.length > 0 &&
                    pkgOptions.map((p) => {
                      const sub = stripMajorPrefix(p.label, majorName);
                      if (!sub) return null; // 메이저만 있는 항목은 스킵
                      return (
                        <option key={p.id} value={p.label}>
                          {sub}
                        </option>
                      );
                    })}
                </select>
              )}

              {/* 자유 입력 가능 */}
              <input
                className="field__control"
                placeholder={pkgOptions?.length > 0 ? "서브 패키지 직접 입력" : "예: 3, 5, 10*20, 300mil"}
                value={pkgAuto ? `${pkgText} (패키지 미리보기)` : pkgText}
                onChange={(e) => {
                  setPkgText(e.target.value); 
                  setPkgAuto(false);
                }}
                onFocus={() => {
                  if (pkgAuto) {
                    setPkgAuto(false);
                    setPkgText("");
                  }
                }}
                disabled={!selMajorPkg || lockCatPkg}
                list={pkgOptions?.length > 0 ? undefined : "pkg-list"}
              />

              {/* 옵션 없을 때만 datalist 자동완성 */}
              {!(pkgOptions?.length > 0) && (
                <datalist id="pkg-list">
                  {pkgOptions.map((p) => (
                    <option key={p.id} value={p.label} />
                  ))}
                </datalist>
              )}
            </div>
            
            {/* 스펙 */}
            <div className="field">
              <div className="field__label">스펙 (옵션)</div>
              <input
                className="field__control"
                placeholder="예: 10K, 22uF/16V"
                value={newValue}
                readOnly
                onClick={() => openSpecEditor()}
                onFocus={(e) => {
                  e.target.blur();
                  openSpecEditor();
                }}
                disabled={!selMajorPkg || lockCatPkg}
              />
            </div>

            {/* 수량 */}
            <div className="field">
              <div className="field__label">입고 수량</div>
              <input
                className={`field__control ${qty ? "" : "highlight"}`}
                type="number"
                min="1"
                placeholder="예: 10"
                value={qty}
                onChange={(e) => setQty(e.target.value)}
                // onKeyDown={(e) => e.key === "Enter" && submitAddProduct()}
              />
            </div>

            {/* 상태 */}
            <div className="field">
              <div className="field__label">상태</div>
              <select
                className="field__control highlight"
                value={selState}
                onChange={(e) => setSelState(e.target.value)}
              >
                <option value="">선택</option>
                {stateOptions.map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.name}
                  </option>
                ))}
              </select>
            </div>

            {/* 보관 위치 */}
            <div className="field">
              <div className="field__label">보관 위치</div>

              <AutocompleteSelect
                value={selLocation}
                text={locText}
                setText={setLocText}
                options={locList}
                getLabel={(l) => l.name_full || ""}
                placeholder="예: A-01"
                disabled={!!locLock}
                lockStyle={!!selLocation}
                onSelect={(l) => {
                  setSelLocation(String(l.id));
                }}
                onClear={() => {
                  setSelLocation("");
                }}
              />
            </div>

            {/* 구매처 */}
            <div className="field">
              <div className="field__label">구매처</div>
              <div className="field__stack">
                <select
                  className={`field__control ${supplierName ? "" : "highlight"}`}
                  value={supplierName}
                  disabled={(Number(qty) || 0) < 1}
                  onChange={(e) => setSupplierName(e.target.value)}
                >
                  <option value="">선택</option>
                  {supplierList.map(s => (
                    <option key={s.id} value={s.name}>{s.name}</option>
                  ))}
                </select>
              </div>
            </div>

            {/* 단가 */}
            <div className="field">
              <div className="field__label">단가</div>
              <input
                className={`field__control ${unitPrice ? "" : "highlight"}`}
                placeholder="예: 120.50"
                value={unitPrice}
                onChange={(e) => setUnitPrice(e.target.value)}
                inputMode="decimal"
                disabled={(Number(qty) || 0) < 1}
              />
            </div>
          </div>
            
          {/* 설명 */}
          <div className="field field--full">
            <div className="field__label">설명 (옵션)</div>
            <textarea
              className="field__control field__control--area"
              placeholder="용도, 특징 등 메모"
              value={descText}
              onChange={(e) => setDescText(e.target.value)}
              disabled={!selMajorPkg || lockCatPkg}
            />
          </div>

          <div className="form-actions">
            {/* <button 
              type="button"
              className="blue-btn"
              onClick={openSpecEditor}
            >
              스펙 편집기
            </button> */}
            <button
              type="button"
              className="blue-btn"
              onClick={() => setSupModal({
                open: true,
                name: supplierName || "",
                address: "",
                description: ""
              })}
            >
              신규 구매처
            </button>
            <button 
              type="button"
              className="blue-btn"
              onClick={submitAddProduct}
            >
              + 품목 추가
            </button>
          </div>
        </div>
      </div>
      )}

      <div className={`form-dock ${selected ? "open" : ""}`}>
        <div className="form-inner">
          <div className="sel-title-row">
            <div className="sel-title">
              {selected ? (
                <>선택된 품목: <b>{selected.product__name || selected.name}</b> (현재 재고: {selected.stock ?? 0})</>
              ) : (<>입고할 품목을 목록에서 선택하세요</>)}
            </div>
            <button
              onClick={() => {setSelected(null); setQty(""); setMsg(""); }}
              style={{ border: "none", background: "transparent", fontSize: 18, cursor: "pointer"}}
              aria-label="닫기"
              title="닫기"
            >
              ×
            </button>
          </div>
          <div className="form-grid">
            <label className="qty-label">입고 수량</label>
            <input
              ref={qtyRef}
              className="qty-input"
              type="number"
              min="1"
              placeholder="수량"
              value={qty}
              onChange={(e) => setQty(e.target.value)}
              // onKeyDown={(e) => e.key === "Enter" && handleStockIn()}
              disabled={!selected}
            />

            <label>구매처</label>
            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <select
                className="modal-input"
                value={supplierName}
                onChange={(e)=>setSupplierName(e.target.value)}
                disabled={!selected}
                style={{ flex: 1 }}
              >
                <option value="">구매처 선택</option>
                {supplierList.map(s => (
                  <option key={s.id} value={s.name}>{s.name}</option>
                ))}
              </select>

              <button
                type="button"
                className="blue-btn"
                onClick={() => setSupModal({
                  open: true,
                  name: supplierName || "",
                  address: "",
                  description: ""
                })}
                disabled={!selected}
                style={{ whiteSpace: "nowrap" }}
              >
                신규 구매처
              </button>
            </div>

            <label>단가</label>
            <input
              className="modal-input"
              placeholder="예: 120.50"
              value={unitPrice}
              onChange={(e)=>setUnitPrice(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleStockIn()}
              disabled={!selected}
            />

            <label>담당자</label>
            <input type="text" value={username} disabled />
          </div>

          <div className="form-actions">
            <button
              className="blue-btn"
              onClick={handleStockIn} 
              disabled={!selected}
            >
              입고
            </button>
          </div>
        </div>
      </div>

      {supModal.open && (
        <div className="modal-backdrop">
          <div className="modal-card" role="dialog" aria-modal="true">
            <div className="modal-header">
              <strong>구매처 추가</strong>
              <button className="modal-close" onClick={() => setSupModal({ open: false, name: "", address: "", description: "" })}>×</button>
            </div>

            <div className="modal-body">
              <div className="modal-row">
                <div className="modal-label">이름</div>
                <div className="modal-value">
                  <input
                    className="modal-input"
                    value={supModal.name}
                    onChange={(e) => setSupModal(s => ({ ...s, name: e.target.value }))}
                    placeholder="예: 혜윰솔루션"
                    autoFocus
                  />
                </div>
              </div>

              <div className="modal-row">
                <div className="modal-label">주소(옵션)</div>
                <div className="modal-value">
                  <input
                    className="modal-input"
                    value={supModal.address}
                    onChange={(e) => setSupModal(s => ({ ...s, address: e.target.value }))}
                    placeholder="도로명/URL 등"
                  />
                </div>
              </div>

              <div className="modal-row">
                <div className="modal-label">설명(옵션)</div>
                <div className="modal-value">
                  <textarea
                    className="modal-input"
                    style={{ minHeight: 90 }}
                    value={supModal.description}
                    onChange={(e) => setSupModal(s => ({ ...s, description: e.target.value }))}
                    placeholder="기타 메모"
                  />
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button className="blue-btn" onClick={createSupplier}>구매처 추가</button>
            </div>
          </div>
        </div>
      )}

      {specOpen && (
        <div className="modal-backdrop">
          <div className="modal-card" role="dialog" aria-modal="true" style={{ maxWidth: 900 }}>
            <div className="modal-header">
              <strong>스펙 편집기</strong>
              <button className="modal-close" onClick={closeSpecEditor}>×</button>
            </div>

            <div className="modal-body">
              {/* 그룹 선택 */}
              <div className="modal-row">
                <div className="modal-label">그룹</div>
                <div className="modal-value" style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <select
                    className="modal-input"
                    value={specGroup}
                    onChange={(e) => {
                      const g = e.target.value
                      setSpecGroup(g)
                      setSpecValues({})

                      if (excelSpecTarget?.mode === "excel") {
                        const rowId = excelSpecTarget.rowId
                        setExcelRows(prev =>
                          prev.map(r => (
                            r.__id === rowId
                              ? { ...r, __specGroup: g }
                              : r
                          ))
                        )
                      }
                    }}
                    style={{ flex: 1 }}
                  >
                    <option value="">선택</option>
                    {getGroupsList().map((g) => (
                      <option key={g} value={g}>
                        {g} {specMeta?.groups?.[g]?.label ? `- ${specMeta.groups[g].label}` : ""}
                      </option>
                    ))}
                  </select>

                  <button
                    className="blue-btn"
                    type="button"
                    onClick={() => {
                      setSpecValues({});
                      setSpecJson("{}");
                    }}
                    disabled={!specGroup}
                    style={{ whiteSpace: "nowrap" }}
                  >
                    초기화
                  </button>
                </div>
              </div>

              {/* 동적 입력폼 */}
              {specGroup ? (
                <div style={{ marginTop: 12 }}>
                  {Object.entries(getGroupFields(specGroup)).map(([fname, fdef]) => {
                    const typ = fdef?.type || "text";
                    const label = fdef?.label || fname;
                    const choices = Array.isArray(fdef?.choices) ? fdef.choices : [];
                    const multi = fdef?.multi === true;

                    const value = specValues?.[fname];

                    // bool
                    if (typ === "bool") {
                      return (
                        <div className="modal-row" key={fname}>
                          <div className="modal-label">{label}</div>
                          <div className="modal-value">
                            <select
                              className="modal-input"
                              value={value === true ? "true" : value === false ? "false" : ""}
                              onChange={(e) => {
                                const v = e.target.value;
                                setSpecValues((s) => ({
                                  ...s,
                                  [fname]: v === "" ? "" : v === "true"
                                }));
                              }}
                            >
                              <option value="">미지정</option>
                              <option value="true">예</option>
                              <option value="false">아니오</option>
                            </select>
                          </div>
                        </div>
                      );
                    }

                    // choice
                    if (choices.length > 0) {
                      if (multi) {
                        const arr = Array.isArray(value)
                          ? value
                          : String(value ?? "")
                              .split(fdef?.sep || "|")
                              .map((x) => x.trim())
                              .filter(Boolean);

                        return (
                          <div className="modal-row" key={fname}>
                            <div className="modal-label">{label}</div>
                            <div className="modal-value">
                              <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                                {choices.map((c) => {
                                  const on = arr.includes(String(c.value));
                                  return (
                                    <button
                                      key={String(c.value)}
                                      type="button"
                                      className={on ? "blue-btn" : "excel-btn"}
                                      onClick={() => {
                                        const next = on
                                          ? arr.filter((x) => x !== String(c.value))
                                          : [...arr, String(c.value)];
                                        setSpecValues((s) => ({ ...s, [fname]: next }));
                                      }}
                                      style={{ padding: "6px 10px" }}
                                    >
                                      {c.label}
                                    </button>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        );
                      }

                      return (
                        <div className="modal-row" key={fname}>
                          <div className="modal-label">{label}</div>
                          <div className="modal-value">
                            <select
                              className="modal-input"
                              value={String(value ?? "")}
                              onChange={(e) => {
                                const v = e.target.value;
                                setSpecValues((s) => ({ ...s, [fname]: v }));
                              }}
                            >
                              <option value="">선택</option>
                              {choices.map((c) => (
                                <option key={String(c.value)} value={String(c.value)}>
                                  {c.label}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      );
                    }

                    // default input
                    return (
                      <div className="modal-row" key={fname}>
                        <div className="modal-label">{label}</div>
                        <div className="modal-value">
                          <input
                            className="modal-input"
                            value={String(value ?? "")}
                            onChange={(e) => setSpecValues((s) => ({ ...s, [fname]: e.target.value }))}
                            placeholder={fname}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div style={{ color: "#666", marginTop: 8 }}>그룹을 선택하면 입력 폼이 표시됩니다.</div>
              )}

              {/* 결과 JSON (한 줄) */}
              <div style={{ marginTop: 16 }}>
                <strong>JSON</strong>

                <textarea
                  className={`modal-input ${isSpecJsonCellError(specGroup, specValues) ? "error" : ""}`}
                  style={{ minHeight: 120, fontFamily: "monospace" }}
                  value={specJson}
                  readOnly
                />

                {/* {specCopyMsg && (
                  <div style={{ marginTop: 6, color: "#86efac" }}>
                    {specCopyMsg}
                  </div>
                )} */}
              </div>
            </div>

            <div className="modal-footer">
              <button className="blue-btn"
                onClick={copySpecJson} 
                disabled={!specGroup}
              > 
                복사 
              </button>
              <button
                className="blue-btn"
                onClick={applySpecJson}
                disabled={!specGroup || isSpecJsonCellError(specGroup, specValues)}
              >
                적용
              </button>
              {/* <button className="blue-btn" onClick={closeSpecEditor}>닫기</button> */}
            </div>
          </div>
        </div>
      )}

      {similarOpen && (
        <div className="modal-backdrop">
          <div className="modal-card" role="dialog" aria-modal="true" style={{ maxWidth: 820 }}>
            <div className="modal-header">
              <strong>
                유사 품목 - {String(newName || "").trim() || "-"}
              </strong>
              <button className="modal-close" onClick={() => setSimilarOpen(false)}>×</button>
            </div>

            <div className="modal-body">
              {similarLoading ? (
                <div style={{ color: "#666" }}>불러오는 중...</div>
              ) : (similarList.length === 0 ? (
                <div style={{ color: "#666" }}>유사 품목이 없습니다.</div>
              ) : (
                <table className="modal-table" style={{ marginTop: 8 }}>
                  <thead>
                    <tr>
                      <th style={{ width: 80 }}>유사도</th>
                      <th>품명</th>
                      <th>패키지</th>
                      <th>스펙</th>
                      <th>설명</th>
                      <th style={{ width: 90 }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {similarList.map((p) => (
                      <tr key={p.id}>
                        <td>{p.score ?? 0}%</td>
                        <td>{p.name || ""}</td>
                        <td>{p.package_label || ""}</td>
                        <td>{p.display_spec || ""}</td>
                        <td>{p.description || ""}</td>
                        <td>
                          <button
                            type="button"
                            className="blue-btn"
                            onClick={() => applySimilarToAddForm(p)}
                          >
                            변경
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ))}
            </div>

            {/* <div className="modal-footer">
              <button className="blue-btn" onClick={() => setSimilarOpen(false)}>닫기</button>
            </div> */}
          </div>
        </div>
      )}

      {excelSimilarOpen && (
        <div className="modal-backdrop">
          <div className="modal-card" role="dialog" aria-modal="true" style={{ maxWidth: 820 }}>
            <div className="modal-header">
              <strong>
                유사 품목 - {String(excelSimilarTarget?.query || "").trim() || "-"}
                {/* {typeof excelSimilarBest === "number" ? ` - best ${excelSimilarBest}%` : ""} */}
              </strong>
              <button className="modal-close" onClick={() => setExcelSimilarOpen(false)}>×</button>
            </div>

            <div className="modal-body">
              {excelSimilarLoading ? (
                <div style={{ color: "#666" }}>불러오는 중...</div>
              ) : (excelSimilarList.length === 0 ? (
                <div style={{ color: "#666" }}>유사 품목이 없습니다.</div>
              ) : (
                <table className="modal-table" style={{ marginTop: 8 }}>
                  <thead>
                    <tr>
                      <th style={{ width: 80 }}>유사도</th>
                      <th>품명</th>
                      <th>패키지</th>
                      <th>스펙</th>
                      <th>설명</th>
                      <th style={{ width: 90 }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {excelSimilarList.map((p) => (
                      <tr key={p.id}>
                        <td>{p.score ?? 0}%</td>
                        <td>{p.name || ""}</td>
                        <td>{p.package_label || ""}</td>
                        <td>{p.display_spec || ""}</td>
                        <td>{p.description || ""}</td>
                        <td>
                          <button
                            className="blue-btn"
                            type="button"
                            onClick={() => applySimilarToExcelRow(p)}
                          >
                            변경
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* {msg && <div className="toast">{msg}</div>} */}
    </div>
  );
}
